export default [
  {
    id: 'recDOUUTrC9JbSJwY',
    fields: {
      raceNumber: 1020,
      paths:
        '[[[238,443],[240,441],[84,400],[34,208],[30,128],[55,131],[239,177]],[[305,254],[311,253],[498,317],[494,277],[368,72],[300,45],[306,88]],[[143,483],[138,482],[82,406],[73,220],[147,130]],[[168,441],[174,430],[213,370],[256,114],[247,96],[175,63]],[[326,428],[325,429],[349,433],[449,384],[398,58],[309,28],[259,146],[330,192]],[[229,410],[231,411],[317,368],[387,180],[401,44],[232,29],[223,78]],[[177,298],[178,299],[145,318],[110,316],[59,328],[30,268],[108,218],[174,136],[173,73]],[[317,558],[319,556],[230,491],[200,492],[139,416],[236,335],[316,247],[268,178],[303,144]],[[214,393],[209,396],[51,124],[121,88],[212,61],[216,77]],[[274,455],[277,456],[467,369],[463,347],[445,325],[446,123],[409,124],[379,153],[313,162],[282,95],[271,60]]]',
      times: '[6617,6655,4473,6048,8056,6520,9112,7865,5904,9960]',
      correct: '[false,false,true,true,true,true,false,true,false,false]',
      score: '5',
      time: 71210,
      started: true,
      name: 'Megan Carter-Davies',
    },
    createdTime: '2020-12-26T11:22:07.000Z',
  },
  {
    id: 'recsEhaBc7um6kxxr',
    fields: {
      raceNumber: 1021,
      paths:
        '[[[238,443],[257,389],[223,13],[211,13],[232,176]],[[305,254],[44,191],[38,171],[160,47],[196,40],[215,70],[301,92]],[[143,483],[65,365],[63,220],[145,136]],[[168,441],[211,369],[39,242],[161,63],[168,64]],[[326,428],[446,392],[400,59],[301,28],[249,155],[330,190]],[[229,410],[299,380],[408,87],[392,40],[221,23],[224,77]],[[177,298],[200,319],[330,216],[246,110],[185,127],[171,73]],[[317,558],[142,426],[255,327],[324,243],[260,173],[311,145]],[[214,393],[174,312],[206,299],[221,300],[136,74],[202,53],[215,69],[214,74]],[[274,455],[421,414],[472,362],[449,338],[436,124],[410,125],[327,168],[271,53]]]',
      times: '[5034,12904,7874,9305,10328,10948,6344,8511,9504,13844]',
      correct: '[true,true,true,false,true,true,true,true,true,false]',
      score: '8',
      time: 94596,
      started: true,
      name: 'Ben Mitchell',
    },
    createdTime: '2020-12-26T11:22:07.000Z',
  },
  {
    id: 'recLWbGtuahsfHNIJ',
    fields: {
      raceNumber: 1033,
      paths:
        '[[[238,443],[255,387],[249,131],[215,9],[203,20],[233,173]],[[305,254],[46,206],[39,161],[195,38],[217,52],[252,60],[270,80],[303,89]],[[143,483],[77,390],[67,224],[139,138]],[[168,441],[213,369],[191,220],[257,112],[189,62],[173,66]],[[326,428],[343,426],[354,440],[449,382],[397,57],[309,29],[253,150],[325,192]],[[229,410],[166,364],[42,268],[28,260],[46,8],[227,20],[223,76]],[[177,298],[205,321],[323,224],[246,108],[191,128],[169,74]],[[317,558],[231,487],[141,433],[138,407],[325,248],[258,182],[292,148],[305,151]],[[214,393],[163,314],[194,300],[220,303],[219,289],[206,276],[135,80],[206,56],[213,84]],[[274,455],[445,390],[474,356],[452,340],[252,298],[311,172],[271,55]]]',
      times: '[10975,16080,9144,10576,12761,17239,16073,13856,14881,14432]',
      correct: '[true,true,true,false,true,false,true,true,true,false]',
      score: '7',
      time: 136017,
      started: true,
      name: 'Matthias Mahr',
    },
    createdTime: '2020-12-26T11:22:07.000Z',
  },
  {
    id: 'rec1iRyPCIBCgyBgW',
    fields: {
      raceNumber: 1036,
      paths:
        '[[[238,443],[237,444],[250,388],[252,205],[224,15],[213,17],[234,170]],[[305,254],[308,254],[498,316],[460,175],[354,64],[298,43],[299,91]],[[143,483],[143,482],[83,387],[72,216],[141,138]],[[168,441],[168,441],[211,374],[260,254],[256,115],[182,68],[174,72]],[[326,428],[329,427],[352,437],[447,386],[399,61],[310,33],[257,143],[327,192]],[[229,410],[226,412],[304,375],[389,188],[405,39],[227,28],[220,70]],[[177,298],[176,300],[148,315],[134,311],[70,322],[23,277],[177,137],[172,74]],[[317,558],[315,558],[218,492],[132,421],[315,252],[265,177],[305,152]],[[214,393],[214,396],[56,117],[203,54],[214,79]],[[274,455],[276,458],[49,317],[47,252],[268,55]]]',
      times: '[15560,15808,10296,16792,18688,20047,14688,14729,12184,10376]',
      correct: '[true,true,true,true,true,true,false,true,false,true]',
      score: '7.5',
      time: 149168,
      started: true,
      name: 'Andrew Stemp',
    },
    createdTime: '2020-12-26T11:22:07.000Z',
  },
  {
    id: 'reckZicV56HfOJj95',
    fields: {
      raceNumber: 1051,
      paths:
        '[[[238,443],[262,381],[231,16],[195,16],[231,171]],[[305,254],[18,190],[95,71],[203,36],[210,72],[278,83],[300,93]],[[143,483],[17,392],[65,214],[139,130]],[[168,441],[220,372],[274,249],[241,203],[266,106],[178,60]],[[326,428],[358,438],[432,387],[453,388],[411,149],[398,58],[300,28],[256,146],[319,180],[324,200]],[[229,410],[183,370],[193,194],[400,198],[412,28],[296,16],[225,13],[223,64],[222,73]],[[177,298],[210,324],[340,211],[245,100],[175,138],[169,63]],[[317,558],[226,483],[186,488],[125,413],[321,250],[254,172],[310,150]],[[214,393],[19,139],[144,60],[214,58],[213,87]],[[274,455],[37,299],[48,227],[266,51]]]',
      times: '[9976,14163,6919,14316,23511,15822,13429,11615,7692,8774]',
      correct: '[true,true,true,true,true,false,true,true,false,true]',
      score: '7.5',
      time: 126217,
      started: true,
      name: 'Calum Robertson',
    },
    createdTime: '2020-12-26T11:22:07.000Z',
  },
  {
    id: 'recT0vdzewRsAcyHg',
    fields: {
      raceNumber: 1052,
      paths:
        '[[[238,443],[261,397],[203,415],[150,414],[99,412],[74,395],[52,319],[35,234],[29,186],[29,150],[27,127],[49,124],[234,171]],[[305,254],[157,221],[33,187],[51,150],[93,96],[171,42],[207,38],[214,62],[231,55],[273,56],[304,65],[306,90]],[[143,483],[313,259],[145,132]],[[168,441],[215,375],[37,245],[164,61]],[[326,428],[345,430],[353,444],[440,390],[450,384],[410,122],[393,57],[302,25],[255,148],[323,193]],[[229,410],[313,388],[340,234],[398,184],[400,43],[227,22],[220,77]],[[177,298],[150,319],[134,307],[64,337],[21,276],[189,137],[170,70]],[[317,558],[227,486],[211,494],[125,419],[184,384],[215,358],[297,275],[324,239],[257,182],[293,139],[307,148]],[[214,393],[49,111],[204,53],[215,81]],[[274,455],[114,361],[35,295],[47,238],[162,154],[256,61],[269,57]]]',
      times: '[20004,21084,8313,11232,19326,14071,11862,17284,9148,10447]',
      correct: '[false,true,false,false,true,true,false,true,false,true]',
      score: '4.5',
      time: 142771,
      started: true,
      name: 'Maja Robertson',
    },
    createdTime: '2020-12-26T11:22:07.000Z',
  },
  {
    id: 'recX0c2ZzqhAb9VSO',
    fields: {
      raceNumber: 1064,
      paths:
        '[[[238,443],[262,400],[219,11],[225,179],[234,175]],[[305,254],[34,183],[116,72],[205,38],[306,90]],[[143,483],[74,370],[59,226],[141,136]],[[168,441],[215,370],[256,126],[254,102],[176,64]],[[326,428],[398,394],[451,393],[406,59],[307,30],[249,146],[323,189]],[[229,410],[317,355],[397,178],[403,37],[225,23],[224,78]],[[177,298],[155,309],[71,333],[21,280],[181,150],[174,67]],[[317,558],[229,488],[120,415],[325,248],[257,179],[300,142],[305,151]],[[214,393],[160,313],[47,125],[201,50],[218,80]],[[274,455],[470,375],[448,329],[439,120],[414,119],[319,177],[274,57]]]',
      times: '[12216,13066,7182,6606,13572,11134,15139,13516,16252,16064]',
      correct: '[true,true,true,true,true,true,false,true,false,false]',
      score: '7',
      time: 124747,
      started: true,
      name: 'Fiona Hendrie',
    },
    createdTime: '2020-12-26T11:22:07.000Z',
  },
  {
    id: 'recx5iLSbLY6IdW5e',
    fields: {
      raceNumber: 1065,
      paths:
        '[[[238,443],[259,397],[227,16],[207,16],[235,183],[228,177]],[[305,254],[500,315],[418,111],[297,43],[294,54],[293,83],[304,95]],[[143,483],[317,256],[147,132]],[[168,441],[213,370],[189,222],[263,108],[181,63],[174,67]],[[326,428],[350,442],[455,389],[399,59],[306,28],[253,144],[328,193]],[[229,410],[311,368],[398,174],[405,33],[225,20],[220,74]],[[177,298],[203,327],[333,225],[249,104],[186,134],[172,68]],[[317,558],[218,485],[207,492],[134,416],[191,386],[320,246],[252,175],[300,149]],[[214,393],[46,118],[206,50],[218,77]],[[274,455],[49,319],[39,244],[203,122],[268,52]]]',
      times: '[11962,13810,6884,12271,16238,10934,10786,15402,8184,10676]',
      correct: '[true,true,false,false,true,true,true,true,false,true]',
      score: '7',
      time: 117147,
      started: true,
      name: 'Ian Hendrie',
    },
    createdTime: '2020-12-25T15:53:57.000Z',
  },
  {
    id: 'recW9XMMcmqXkvYTe',
    fields: {
      raceNumber: 1079,
      paths:
        '[[[238,443],[263,404],[239,55],[214,10],[205,16],[232,172]],[[305,254],[46,196],[34,178],[146,58],[205,42],[214,74],[289,86],[303,91]],[[143,483],[311,257],[154,127],[141,134]],[[168,441],[222,369],[249,133],[259,113],[189,60],[173,62]],[[326,428],[376,406],[379,396],[413,403],[440,392],[453,380],[399,57],[306,30],[253,144],[321,191]],[[229,410],[189,373],[178,201],[36,157],[47,13],[226,31],[225,76]],[[177,298],[185,298],[201,320],[331,222],[250,108],[191,126],[181,112],[171,72]],[[317,558],[222,495],[177,478],[135,416],[190,382],[318,253],[314,230],[261,177],[290,148],[306,148]],[[214,393],[167,315],[197,298],[221,306],[221,291],[202,269],[132,82],[203,54],[215,81]],[[274,455],[153,391],[46,306],[38,268],[61,229],[210,115],[272,54]]]',
      times: '[9489,14009,9782,13793,19952,16526,15231,17560,12072,16126]',
      correct: '[true,true,false,true,true,false,true,true,true,true]',
      score: '8',
      time: 144540,
      started: true,
      name: 'Don Bayly',
    },
    createdTime: '2020-12-26T11:22:07.000Z',
  },
  {
    id: 'recXJqGDyXwYk6cpF',
    fields: {
      raceNumber: 1092,
      paths:
        '[[[238,443],[263,393],[233,18],[208,14],[234,172]],[[305,254],[497,316],[488,244],[398,86],[302,47],[290,60],[267,69],[306,94]],[[143,483],[76,385],[69,218],[134,134]],[[168,441],[216,360],[197,219],[260,103],[183,63],[176,63]],[[326,428],[445,388],[430,240],[384,53],[305,34],[265,148],[326,192]],[[229,410],[188,358],[178,196],[31,148],[48,10],[225,29],[223,81]],[[177,298],[145,320],[134,307],[66,330],[23,280],[180,139],[175,72]],[[317,558],[202,488],[128,417],[207,360],[318,245],[264,179],[302,141],[310,144]],[[214,393],[313,378],[381,313],[271,59],[215,82]],[[274,455],[468,367],[446,331],[438,127],[405,121],[335,177],[287,120],[277,58]]]',
      times: '[10824,14663,8360,11425,13968,14455,12320,20033,7825,13384]',
      correct: '[true,true,true,false,true,false,false,true,false,false]',
      score: '4.5',
      time: 127257,
      started: true,
      name: 'Simon Errington',
    },
    createdTime: '2020-12-26T11:22:07.000Z',
  },
  {
    id: 'recTIZ2EshFq3hiQn',
    fields: {
      raceNumber: 1093,
      paths:
        '[[[238,443],[268,431],[263,222],[248,111],[221,10],[204,16],[228,111],[235,173]],[[305,254],[193,223],[41,191],[38,157],[124,69],[191,32],[211,50],[238,53],[252,59],[250,78],[276,86],[298,89],[307,95]],[[143,483],[45,421],[121,323],[132,289],[62,227],[92,185],[132,140]],[[168,441],[183,426],[215,372],[192,218],[232,159],[264,105],[203,64],[172,64]],[[326,428],[348,430],[358,442],[452,388],[423,185],[400,58],[363,45],[306,31],[277,95],[255,152],[328,194]],[[229,410],[190,358],[189,180],[35,165],[42,12],[173,13],[229,21],[223,45],[226,80]],[[177,298],[159,318],[137,305],[86,328],[24,270],[149,172],[185,131],[170,89],[171,71]],[[317,558],[233,484],[213,497],[128,411],[199,377],[260,310],[324,246],[261,179],[302,141],[309,141]],[[214,393],[171,313],[198,296],[217,307],[223,288],[186,208],[133,78],[205,52],[218,82]],[[274,455],[312,439],[470,361],[471,372],[455,339],[398,344],[253,298],[262,269],[308,182],[292,98],[279,57]]]',
      times: '[16816,16425,9889,11457,18737,15280,16160,19039,14361,18505]',
      correct: '[true,true,true,false,true,false,false,true,true,false]',
      score: '6',
      time: 156669,
      started: true,
      name: 'Helen Errington',
    },
    createdTime: '2020-12-26T11:22:07.000Z',
  },
  {
    id: 'recGozz5o7QPcHlkG',
    fields: {
      raceNumber: 1113,
      paths:
        '[[[238,443],[85,399],[37,214],[27,127],[237,172]],[[305,254],[44,195],[31,176],[193,41],[214,74],[298,87],[307,94]],[[143,483],[34,412],[69,220],[141,135]],[[168,441],[212,367],[256,120],[259,108],[170,66]],[[326,428],[352,434],[448,383],[433,265],[394,54],[304,29],[253,142],[326,193]],[[229,410],[298,379],[393,182],[398,41],[223,27],[225,79]],[[177,298],[202,323],[331,222],[244,108],[179,129],[170,68]],[[317,558],[202,487],[136,419],[188,386],[322,245],[259,179],[295,141],[307,147]],[[214,393],[51,119],[199,52],[217,79]],[[274,455],[97,345],[39,287],[48,236],[266,55]]]',
      times: '[10789,16785,8049,12193,14419,15184,11549,13808,8664,9792]',
      correct: '[false,true,true,true,true,true,true,true,false,true]',
      score: '8',
      time: 121232,
      started: true,
      name: 'Tobias Danninger',
    },
    createdTime: '2020-12-26T11:22:07.000Z',
  },
  {
    id: 'recRwR6AJ0n3Rl0NC',
    fields: {
      raceNumber: 1131,
      paths:
        '[[[238,443],[51,286],[23,129],[38,126],[235,175]],[[305,254],[492,314],[478,215],[378,71],[303,41],[294,54],[262,57],[258,74],[289,86],[303,92]],[[143,483],[317,258],[225,190],[144,138]],[[168,441],[216,366],[189,216],[264,109],[180,61],[174,64]],[[326,428],[320,463],[154,552],[29,389],[253,148],[327,194]],[[229,410],[374,291],[401,40],[223,25],[224,74]],[[177,298],[196,320],[335,216],[252,100],[181,133],[175,114],[173,69]],[[317,558],[218,485],[187,487],[131,411],[328,247],[254,177],[282,143],[304,149]],[[214,393],[384,321],[278,55],[217,74]],[[274,455],[42,316],[42,227],[195,118],[271,52]]]',
      times: '[9207,12792,5696,10760,9952,10128,10817,13176,9521,7928]',
      correct: '[false,true,false,false,false,true,true,true,false,true]',
      score: '5',
      time: 99977,
      started: true,
      name: 'Alex Soulsby',
    },
    createdTime: '2020-12-26T11:22:07.000Z',
  },
  {
    id: 'recnhd5TKkclYs8hJ',
    fields: {
      raceNumber: 1133,
      paths:
        '[[[238,443],[261,393],[227,8],[213,24],[237,173]],[[305,254],[32,180],[207,42],[212,53],[304,88]],[[143,483],[48,418],[139,288],[61,225],[140,136]],[[168,441],[216,369],[255,124],[252,90],[173,64]],[[326,428],[438,393],[400,59],[312,29],[252,149],[325,192]],[[229,410],[318,364],[392,184],[407,36],[224,24],[228,77]],[[177,298],[54,329],[22,267],[187,135],[172,73]],[[317,558],[231,488],[202,494],[132,412],[192,380],[301,273],[324,243],[249,174],[302,139],[308,149]],[[214,393],[170,310],[199,302],[221,303],[221,295],[203,277],[136,82],[218,55],[217,85]],[[274,455],[474,352],[257,294],[315,172],[273,57]]]',
      times: '[8761,10549,10800,8448,10386,13425,9362,16481,8842,14319]',
      correct: '[true,false,true,true,true,true,false,true,true,false]',
      score: '7',
      time: 111373,
      started: true,
      name: 'Maggie Soulsby',
    },
    createdTime: '2020-12-26T11:22:07.000Z',
  },
  {
    id: 'recYHQP9CqriuBx0j',
    fields: {
      raceNumber: 1134,
      paths:
        '[[[238,443],[227,409],[265,410],[234,3],[208,20],[238,177]],[[305,254],[40,186],[191,13],[217,69],[305,89]],[[143,483],[308,259],[143,135]],[[168,441],[224,366],[250,126],[274,100],[176,64]],[[326,428],[142,553],[27,390],[246,148],[322,190]],[[229,410],[319,372],[373,299],[399,191],[414,37],[226,27],[230,71],[226,77]],[[177,298],[61,331],[15,268],[186,139],[174,72]],[[317,558],[220,487],[124,419],[75,322],[182,271],[141,177],[255,179],[308,150]],[[214,393],[162,311],[214,302],[233,288],[196,262],[128,81],[257,54],[209,83]],[[274,455],[146,403],[39,309],[46,234],[202,122],[267,61]]]',
      times: '[6424,5929,4960,5272,7280,11088,7496,9592,10567,5992]',
      correct: '[true,true,false,true,false,true,false,false,true,true]',
      score: '6',
      time: 74600,
      started: true,
      name: 'Alice Soulsby',
    },
    createdTime: '2020-12-26T11:22:07.000Z',
  },
  {
    id: 'recRvzFn8NW3Sw4YS',
    fields: {
      raceNumber: 1142,
      paths:
        '[[[238,443],[261,191],[217,13],[203,21],[230,175]],[[305,254],[497,324],[431,104],[299,41],[292,58],[305,89]],[[143,483],[83,386],[73,219],[139,135]],[[168,441],[222,370],[257,125],[262,106],[171,66]],[[326,428],[418,405],[455,381],[402,60],[300,34],[251,143],[325,196]],[[229,410],[187,353],[173,188],[36,150],[45,13],[223,25],[221,76]],[[177,298],[208,321],[327,221],[249,100],[192,136],[173,80],[173,75]],[[317,558],[233,484],[208,495],[133,414],[317,251],[252,180],[288,136],[306,150]],[[214,393],[164,313],[227,304],[126,84],[201,51],[213,79]],[[274,455],[55,316],[47,228],[269,54]]]',
      times: '[21240,12136,8967,9431,18768,10520,16362,14081,11880,12352]',
      correct: '[true,true,true,true,true,false,true,true,true,true]',
      score: '8.5',
      time: 135737,
      started: true,
      name: 'Mike Smithard',
    },
    createdTime: '2020-12-26T11:22:07.000Z',
  },
  {
    id: 'recJ0AN6xv5ivEOiF',
    fields: {
      raceNumber: 1165,
      paths:
        '[[[238,443],[251,371],[244,124],[224,47],[214,16],[232,173]],[[305,254],[154,210],[43,189],[51,168],[134,67],[203,40],[218,56],[285,65],[303,88]],[[143,483],[92,423],[79,378],[67,210],[137,135]],[[168,441],[212,371],[259,111],[206,73],[174,61]],[[326,428],[316,452],[151,560],[30,388],[256,152],[326,192]],[[229,410],[295,367],[351,322],[399,167],[407,36],[224,24],[223,80]],[[177,298],[205,308],[332,216],[243,113],[188,124],[170,75]],[[317,558],[232,494],[177,470],[134,413],[229,335],[316,242],[262,178],[305,149]],[[214,393],[163,308],[216,297],[200,239],[137,80],[199,56],[214,73],[214,83]],[[274,455],[387,418],[465,354],[452,336],[258,290],[310,179],[283,60],[272,56]]]',
      times: '[5173,6104,4377,5802,7690,7882,7881,7614,7849,9610]',
      correct: '[true,true,true,true,false,true,true,true,true,false]',
      score: '8',
      time: 69982,
      started: true,
      name: 'Andrew Evans',
    },
    createdTime: '2020-12-22T15:00:27.000Z',
  },
  {
    id: 'recXaSpKSA9K7kedq',
    fields: {
      raceNumber: 1167,
      paths:
        '[[[238,443],[240,445],[82,402],[35,225],[28,122],[235,170]],[[305,254],[302,252],[37,178],[103,88],[198,36],[221,52],[258,60],[261,78],[302,89]],[[143,483],[146,485],[32,415],[66,222],[72,200],[143,139]],[[168,441],[177,431],[215,367],[192,215],[263,112],[194,66],[178,66]],[[326,428],[329,430],[319,461],[157,555],[33,383],[255,152],[324,194]],[[229,410],[236,410],[297,377],[390,183],[399,36],[227,25],[225,74]],[[177,298],[181,299],[151,321],[138,308],[57,331],[28,268],[178,138],[172,74]],[[317,558],[311,548],[225,493],[198,492],[136,414],[189,382],[320,243],[258,177],[299,141],[302,144]],[[214,393],[215,392],[173,308],[222,296],[135,79],[211,55],[213,81]],[[274,455],[274,450],[51,314],[36,252],[193,123],[269,53]]]',
      times: '[11976,18968,17932,14880,17319,18528,16508,19432,17644,11896]',
      correct: '[false,true,true,false,false,true,false,true,true,true]',
      score: '6',
      time: 165083,
      started: true,
      name: 'Mike Pedley',
    },
    createdTime: '2020-12-26T11:22:07.000Z',
  },
  {
    id: 'recgfODkvCY0WT7pe',
    fields: {
      raceNumber: 1177,
      paths:
        '[[[238,443],[84,394],[31,226],[25,125],[50,127],[235,169]],[[305,254],[55,197],[33,178],[97,82],[201,39],[218,57],[244,59],[306,96]],[[143,483],[77,395],[63,217],[135,133]],[[168,441],[215,376],[263,252],[252,224],[255,110],[199,65],[169,60]],[[326,428],[409,404],[449,398],[433,259],[395,56],[305,28],[254,146],[323,192]],[[229,410],[301,379],[391,181],[401,41],[225,27],[224,79]],[[177,298],[149,318],[136,299],[63,331],[21,277],[179,139],[173,70]],[[317,558],[231,491],[205,490],[133,421],[187,384],[318,245],[258,171],[294,141],[309,153]],[[214,393],[171,311],[223,301],[218,285],[138,75],[203,51],[221,85]],[[274,455],[135,382],[45,304],[38,242],[199,123],[268,54]]]',
      times: '[12156,14528,7586,8372,15763,11057,10656,16409,13759,13114]',
      correct: '[false,true,true,true,true,true,false,true,true,true]',
      score: '8',
      time: 123400,
      started: true,
      name: 'Martin Ward',
    },
    createdTime: '2020-12-26T11:22:07.000Z',
  },
  {
    id: 'rec23UWMYEdQt3L3l',
    fields: {
      raceNumber: 1180,
      paths:
        '[[[238,443],[259,392],[221,14],[207,17],[231,172]],[[305,254],[300,253],[497,313],[424,127],[307,40],[296,60],[310,79],[309,85],[309,91]],[[143,483],[141,482],[311,251],[142,126],[139,137]],[[168,441],[172,438],[211,365],[196,218],[259,108],[189,60],[170,64]],[[326,428],[338,428],[354,446],[452,384],[397,61],[309,31],[250,147],[319,188]],[[229,410],[237,407],[192,349],[179,183],[42,154],[50,11],[220,25],[224,74]],[[177,298],[177,296],[214,320],[323,214],[247,111],[182,132],[172,72]],[[317,558],[313,558],[224,485],[197,491],[134,412],[321,248],[265,200],[257,171],[308,152]],[[214,393],[212,399],[381,309],[270,53],[217,77]],[[274,455],[274,445],[42,297],[52,235],[265,51]]]',
      times: '[8985,15571,15450,14100,21818,20729,11721,24979,10248,9142]',
      correct: '[true,true,false,false,true,false,true,true,false,true]',
      score: '5',
      time: 152743,
      started: true,
      name: 'Elizabeth Furness',
    },
    createdTime: '2020-12-26T11:22:07.000Z',
  },
  {
    id: 'recRUKtR9NDPbKXzk',
    fields: {
      raceNumber: 1189,
      paths:
        '[[[238,443],[254,203],[223,11],[198,24],[232,173]],[[305,254],[40,197],[62,119],[202,37],[302,94]],[[143,483],[76,387],[63,225],[131,132],[142,132]],[[168,441],[219,376],[33,242],[173,65]],[[326,428],[418,406],[455,392],[399,61],[312,30],[247,148],[324,193]],[[229,410],[399,199],[418,22],[307,23],[229,28],[229,78]],[[177,298],[148,322],[131,299],[59,329],[21,273],[190,140],[175,74]],[[317,558],[221,489],[128,413],[322,247],[258,179],[305,146]],[[214,393],[164,318],[195,299],[225,301],[133,83],[207,53],[215,82]],[[274,455],[468,362],[445,344],[252,302],[315,160],[270,58]]]',
      times: '[11642,8873,8833,8737,14897,11473,13497,21738,13066,11913]',
      correct: '[true,true,true,false,true,false,false,true,true,false]',
      score: '5.5',
      time: 124669,
      started: true,
      name: 'Liz Phillips',
    },
    createdTime: '2020-12-26T11:22:07.000Z',
  },
  {
    id: 'recaunfoYY6zCpJ7b',
    fields: {
      raceNumber: 1199,
      paths:
        '[[[238,443],[257,390],[240,48],[216,8],[208,17],[233,178]],[[305,254],[46,186],[37,173],[202,37],[219,67],[303,86],[306,92]],[[143,483],[79,382],[71,219],[144,132]],[[168,441],[214,371],[194,222],[262,111],[195,59],[170,67]],[[326,428],[349,438],[444,391],[444,310],[400,58],[307,27],[254,150],[326,190]],[[229,410],[309,366],[387,186],[402,38],[226,23],[223,82]],[[177,298],[146,320],[137,303],[66,334],[19,274],[179,142],[170,66]],[[317,558],[233,495],[200,495],[124,415],[180,388],[321,248],[253,180],[296,141],[309,152]],[[214,393],[43,121],[207,55],[214,83]],[[274,455],[166,411],[53,323],[39,292],[42,252],[51,235],[195,128],[270,52]]]',
      times: '[6257,6569,4056,6462,8726,5764,8711,11733,6107,9464]',
      correct: '[true,true,true,false,true,true,false,true,false,true]',
      score: '7',
      time: 73849,
      started: true,
      name: 'Rune De Clercq',
    },
    createdTime: '2020-12-26T11:22:07.000Z',
  },
  {
    id: 'recJHLDGQeNkvkhCC',
    fields: {
      raceNumber: 1200,
      paths:
        '[[[238,443],[88,403],[37,222],[24,128],[228,169]],[[305,254],[30,183],[93,74],[196,34],[214,58],[257,59],[304,97]],[[143,483],[35,411],[35,213],[117,104],[143,120],[139,128]],[[168,441],[219,380],[208,196],[264,103],[167,64]],[[326,428],[350,442],[450,384],[410,124],[400,57],[303,29],[253,146],[320,188]],[[229,410],[312,363],[389,210],[402,35],[225,22],[225,78]],[[177,298],[146,321],[137,301],[69,336],[26,268],[188,136],[168,72]],[[317,558],[220,482],[204,495],[126,413],[228,343],[325,241],[255,175],[298,141],[304,145]],[[214,393],[316,383],[385,298],[261,29],[214,84]],[[274,455],[46,310],[43,232],[197,120],[273,55]]]',
      times: '[12864,15576,12617,16809,16936,13777,15816,14512,8321,10208]',
      correct: '[false,true,false,false,true,true,false,true,false,true]',
      score: '5',
      time: 137436,
      started: true,
      name: 'Sally Wilkinson',
    },
    createdTime: '2020-12-26T11:22:07.000Z',
  },
  {
    id: 'recy2sQnJ8URrp9rR',
    fields: {
      raceNumber: 1201,
      paths:
        '[[[238,443],[258,386],[252,202],[215,10],[231,170]],[[305,254],[47,193],[41,176],[150,57],[207,47],[250,62],[269,83],[307,95]],[[143,483],[82,393],[70,218],[142,133]],[[168,441],[215,368],[255,258],[258,119],[182,63],[177,65]],[[326,428],[420,406],[448,388],[440,270],[397,59],[309,28],[254,155],[325,193]],[[229,410],[291,378],[388,183],[403,41],[224,31],[223,78]],[[177,298],[146,321],[138,308],[64,330],[26,275],[183,138],[173,68]],[[317,558],[229,491],[202,492],[134,420],[189,382],[325,253],[255,178],[292,142],[307,151]],[[214,393],[172,312],[222,299],[137,80],[202,58],[214,83]],[[274,455],[127,368],[42,298],[51,231],[205,122],[269,53]]]',
      times: '[8377,16904,7457,15096,17168,15385,18553,24296,13737,15968]',
      correct: '[true,true,true,true,true,true,false,true,true,true]',
      score: '8.5',
      time: 152941,
      started: true,
      name: 'Clive Wilkinson',
    },
    createdTime: '2020-12-26T11:22:07.000Z',
  },
  {
    id: 'recrlM1HuH3awdF60',
    fields: {
      raceNumber: 1206,
      paths:
        '[[[238,443],[266,412],[223,11],[207,18],[235,175]],[[305,254],[492,323],[458,165],[345,56],[291,44],[279,57],[251,67],[307,92]],[[143,483],[47,427],[135,296],[60,229],[139,133]],[[168,441],[212,368],[190,216],[264,111],[177,63]],[[326,428],[321,466],[447,382],[394,54],[308,29],[257,145],[324,197]],[[229,410],[318,353],[391,205],[407,38],[219,26],[228,81]],[[177,298],[203,322],[331,209],[239,98],[186,133],[165,71]],[[317,558],[219,489],[193,495],[129,417],[323,247],[255,183],[306,152]],[[214,393],[166,312],[198,301],[219,307],[222,291],[204,280],[130,83],[207,54],[214,82]],[[274,455],[468,361],[442,314],[437,122],[342,178],[294,153],[273,56]]]',
      times: '[7321,13444,5215,6850,9500,11518,10819,10384,10110,19066]',
      correct: '[true,true,true,false,false,true,true,true,true,false]',
      score: '7',
      time: 104227,
      started: true,
      name: 'Sarah Darley',
    },
    createdTime: '2020-12-26T11:22:07.000Z',
  },
  {
    id: 'reckdDFBpqE6RFNkU',
    fields: {
      raceNumber: 1207,
      paths:
        '[[[238,443],[261,430],[258,337],[250,221],[239,71],[217,8],[208,19],[235,169]],[[305,254],[263,235],[48,195],[37,177],[95,95],[173,41],[207,38],[216,69],[248,77],[281,91],[301,91]],[[143,483],[91,432],[76,354],[65,215],[138,133]],[[168,441],[216,375],[194,226],[214,183],[262,113],[252,97],[176,63]],[[326,428],[345,428],[349,438],[386,431],[447,393],[438,281],[398,58],[308,29],[250,150],[324,194]],[[229,410],[300,392],[327,323],[392,193],[403,40],[223,21],[225,75]],[[177,298],[147,321],[130,303],[68,335],[22,276],[132,191],[183,141],[173,74]],[[317,558],[267,524],[224,490],[202,498],[133,418],[183,391],[269,306],[324,249],[255,182],[284,146],[308,148]],[[214,393],[201,394],[167,317],[195,295],[216,310],[222,290],[210,284],[130,79],[204,49],[217,77]],[[274,455],[288,441],[393,424],[468,363],[459,340],[443,337],[437,191],[443,107],[406,132],[363,168],[314,171],[287,105],[277,57]]]',
      times: '[10407,13680,6571,10157,14243,10962,14626,15766,14488,18888]',
      correct: '[true,true,true,false,true,true,false,true,true,false]',
      score: '7',
      time: 129788,
      started: true,
      name: 'Aimee Darley',
    },
    createdTime: '2020-12-26T11:22:07.000Z',
  },
  {
    id: 'recwFojOrQb9CB51k',
    fields: {
      raceNumber: 1209,
      paths:
        '[[[238,443],[270,429],[227,16],[201,14],[237,170]],[[305,254],[36,179],[138,45],[207,40],[216,71],[297,87],[309,93]],[[143,483],[321,248],[140,137]],[[168,441],[216,373],[263,109],[172,63]],[[326,428],[410,399],[450,394],[403,55],[301,24],[255,148],[323,189]],[[229,410],[298,368],[413,109],[409,38],[221,22],[221,74]],[[177,298],[203,317],[329,221],[236,99],[190,126],[170,88],[168,69]],[[317,558],[230,486],[205,499],[126,409],[192,383],[324,248],[261,180],[309,135],[309,148]],[[214,393],[47,110],[218,50],[218,77]],[[274,455],[140,383],[46,315],[39,243],[272,55]]]',
      times: '[12904,16817,8408,11984,15256,13088,15032,16343,13192,10192]',
      correct: '[true,true,false,true,true,true,true,true,false,true]',
      score: '8',
      time: 133216,
      started: true,
      name: 'Carol Edwards',
    },
    createdTime: '2020-12-26T11:22:07.000Z',
  },
  {
    id: 'rec8aBhgPJzLFeNtq',
    fields: {
      raceNumber: 1221,
      paths:
        '[[[238,443],[242,436],[254,381],[251,204],[226,10],[203,20],[233,168]],[[305,254],[306,253],[34,180],[97,88],[202,35],[296,41],[294,60],[307,62],[305,88]],[[143,483],[145,480],[311,253],[143,136]],[[168,441],[169,437],[216,372],[264,252],[264,252],[253,227],[253,227],[253,129],[253,129],[259,113],[176,60]],[[326,428],[229,580],[323,424],[342,428],[342,428],[350,437],[448,385],[432,248],[391,56],[305,32],[256,142],[255,148],[324,192]],[[229,410],[229,410],[321,346],[383,300],[408,34],[229,12],[223,70]],[[177,298],[181,299],[181,299],[198,321],[333,216],[239,98],[186,130],[172,75]],[[317,558],[315,557],[203,488],[131,419],[264,310],[329,244],[254,180],[295,135],[306,152]],[[214,393],[214,395],[45,116],[205,52],[216,81]],[[274,455],[273,454],[477,368],[444,342],[442,120],[408,122],[336,178],[336,178],[290,119],[276,52]]]',
      times: '[12465,14968,10512,14378,26112,12567,12104,15104,9921,13886]',
      correct: '[true,true,false,true,false,true,true,true,false,false]',
      score: '6',
      time: 142017,
      started: true,
      name: 'Pauline Tryner',
    },
    createdTime: '2020-12-26T11:22:07.000Z',
  },
  {
    id: 'recqKUjmL62T6pFjW',
    fields: {
      raceNumber: 1222,
      paths:
        '[[[238,443],[263,433],[218,10],[230,169]],[[305,254],[13,186],[204,44],[222,64],[303,88]],[[143,483],[42,429],[64,213],[135,134]],[[168,441],[210,369],[252,115],[174,53],[156,68],[170,70]],[[326,428],[355,435],[450,385],[387,56],[303,31],[261,139],[319,189]],[[229,410],[305,380],[393,197],[406,38],[225,32],[223,75]],[[177,298],[202,318],[327,222],[250,111],[188,126],[172,73]],[[317,558],[212,488],[196,486],[128,396],[326,246],[260,177],[310,147]],[[214,393],[173,326],[52,122],[207,61],[217,80]],[[274,455],[41,283],[55,222],[266,55]]]',
      times: '[5793,6705,3344,4136,7105,5249,5225,6969,5345,11057]',
      correct: '[true,true,true,false,true,true,true,false,false,true]',
      score: '7',
      time: 60928,
      started: true,
      name: 'Euan Tryner',
    },
    createdTime: '2020-12-26T11:22:07.000Z',
  },
  {
    id: 'recn52AvoevuE5Jqp',
    fields: {
      raceNumber: 1223,
      paths:
        '[[[238,443],[82,436],[15,200],[36,124],[233,166]],[[305,254],[34,188],[203,39],[298,91]],[[143,483],[35,415],[59,217],[139,125],[142,139]],[[168,441],[288,276],[265,112],[168,64]],[[326,428],[449,362],[400,56],[306,28],[262,141],[316,196]],[[229,410],[38,256],[51,11],[227,26],[223,81]],[[177,298],[59,354],[32,269],[201,132],[169,68]],[[317,558],[314,596],[131,422],[321,258],[256,173],[307,127],[309,152]],[[214,393],[48,104],[216,80]],[[274,455],[53,228],[198,129],[276,44],[276,56]]]',
      times: '[6552,4712,5241,4609,7536,7248,4913,10839,3000,7608]',
      correct: '[false,false,true,false,false,false,false,true,false,false]',
      score: '2',
      time: 62258,
      started: true,
      name: 'Freya Tryner',
    },
    createdTime: '2020-12-26T11:22:07.000Z',
  },
  {
    id: 'recGNpOTK6YO7a41u',
    fields: {
      raceNumber: 1234,
      paths:
        '[[[238,443],[249,447],[262,440],[251,150],[239,43],[228,25],[222,14],[218,13],[212,12],[208,15],[233,173]],[[305,254],[499,325],[480,200],[444,151],[426,129],[392,85],[367,69],[350,59],[343,55],[299,39],[295,39],[298,54],[299,61],[309,71],[305,81],[307,88]],[[143,483],[319,259],[152,131],[143,135]],[[168,441],[185,429],[219,380],[211,271],[195,245],[192,236],[183,219],[264,110],[214,77],[198,69],[190,66],[171,63]],[[326,428],[331,426],[340,427],[344,430],[349,442],[394,433],[420,414],[449,398],[451,387],[448,380],[444,363],[445,345],[443,331],[399,55],[308,29],[284,73],[271,103],[265,111],[259,124],[258,129],[253,142],[318,190]],[[229,410],[282,395],[304,384],[319,353],[342,201],[402,185],[407,42],[405,37],[324,27],[278,25],[226,25],[221,72]],[[177,298],[200,322],[331,228],[251,102],[186,142],[172,69]],[[317,558],[240,494],[210,493],[129,419],[153,402],[185,384],[325,245],[257,184],[290,145],[306,148]],[[214,393],[390,336],[272,51],[215,73],[216,81]],[[274,455],[69,328],[41,307],[39,252],[51,227],[265,56]]]',
      times: '[8601,8826,4960,12275,20919,13018,10161,19516,8837,11046]',
      correct: '[true,true,false,false,true,true,true,true,false,true]',
      score: '6.5',
      time: 118159,
      started: true,
      name: 'Jonas Newey',
    },
    createdTime: '2020-12-26T11:22:07.000Z',
  },
  {
    id: 'recgPk4XGzwhQRaRB',
    fields: {
      raceNumber: 1235,
      paths:
        '[[[238,443],[241,437],[255,373],[254,202],[215,5],[207,15],[235,171]],[[305,254],[294,243],[23,197],[142,24],[196,35],[211,59],[219,79],[255,73],[291,90],[306,87]],[[143,483],[183,395],[57,416],[140,292],[60,235],[72,187],[139,134]],[[168,441],[222,367],[142,305],[35,246],[167,39],[167,59]],[[326,428],[448,381],[395,55],[301,29],[248,138],[319,185],[320,187]],[[229,410],[190,188],[146,140],[209,81],[227,72]],[[177,298],[178,300],[161,339],[156,319],[124,303],[75,324],[7,287],[66,223],[114,171],[195,118],[173,56],[172,62]],[[317,558],[271,512],[239,483],[103,392],[307,250],[267,171],[301,141],[308,153]],[[214,393],[56,111],[203,43],[214,71],[215,81]],[[274,455],[372,424],[484,369],[446,122],[352,163],[303,158],[255,47],[269,60]]]',
      times: '[8778,14747,7813,5913,6538,7429,7941,7933,4125,7015]',
      correct: '[true,true,false,false,true,false,false,false,false,false]',
      score: '3',
      time: 78232,
      started: true,
      name: 'Yann Newey',
    },
    createdTime: '2020-12-26T11:22:07.000Z',
  },
  {
    id: 'recrt5LsSI5wTDi1B',
    fields: {
      raceNumber: 1251,
      paths:
        '[[[238,443],[242,437],[259,362],[251,186],[222,11],[208,15],[234,169]],[[305,254],[215,228],[53,200],[39,179],[80,106],[132,64],[205,42],[210,66],[223,74],[277,78],[302,95]],[[143,483],[102,433],[79,380],[67,223],[77,205],[142,136]],[[168,441],[212,371],[191,219],[262,111],[199,66],[174,66]],[[326,428],[343,428],[352,439],[423,406],[449,387],[439,305],[417,160],[398,55],[327,35],[308,29],[289,79],[255,152],[277,165],[323,189]],[[229,410],[164,364],[38,265],[30,262],[49,12],[82,15],[223,28],[221,81]],[[177,298],[151,319],[135,306],[65,331],[24,286],[34,262],[177,143],[171,66]],[[317,558],[229,492],[202,489],[134,426],[139,408],[173,392],[215,358],[280,296],[321,250],[308,229],[260,179],[271,161],[293,140],[305,153]],[[214,393],[162,310],[66,160],[55,122],[69,106],[140,77],[204,54],[215,80]],[[274,455],[247,433],[190,409],[123,361],[68,324],[47,308],[41,289],[49,240],[78,224],[139,174],[204,121],[268,57]]]',
      times: '[12373,15336,9319,9249,16796,14234,14394,17418,13233,18438]',
      correct: '[true,true,true,false,true,false,false,true,false,true]',
      score: '6',
      time: 140790,
      started: true,
      name: 'Steffen Hartmann',
    },
    createdTime: '2020-12-26T11:22:07.000Z',
  },
  {
    id: 'recL5SLT0jTpmrn5K',
    fields: {
      raceNumber: 1254,
      paths:
        '[[[238,443],[235,446],[278,409],[217,443],[79,418],[36,357],[36,217],[21,144],[33,131],[77,124],[229,174]],[[305,254],[311,254],[479,315],[501,322],[465,192],[386,79],[301,34],[291,54],[267,55],[252,56],[251,76],[296,92],[301,95]],[[143,483],[140,484],[68,429],[34,404],[55,258],[58,225],[96,181],[121,160],[134,134]],[[168,441],[173,441],[208,393],[223,335],[184,250],[189,209],[235,150],[259,117],[237,81],[168,62]],[[326,428],[327,426],[349,428],[356,440],[429,402],[449,383],[420,213],[393,51],[311,31],[282,83],[262,136],[258,144],[324,189]],[[229,410],[233,403],[315,374],[368,299],[413,148],[414,37],[360,25],[267,24],[231,23],[227,67],[228,75]],[[177,298],[177,285],[84,331],[41,324],[26,273],[87,220],[156,171],[185,149],[177,104],[175,68]],[[317,558],[313,555],[499,370],[565,306],[468,201],[425,158],[324,242],[258,186],[288,146],[305,139],[310,145]],[[214,393],[209,385],[160,313],[183,303],[219,306],[225,279],[129,77],[208,52],[222,74],[216,80]],[[274,455],[277,450],[79,343],[39,267],[126,180],[203,118],[253,67],[272,59]]]',
      times: '[13215,14560,14342,10633,18436,11724,10603,15583,14729,9674]',
      correct: '[false,true,true,false,true,true,false,false,true,true]',
      score: '6',
      time: 133499,
      started: true,
      name: 'Rhona Fraser',
    },
    createdTime: '2020-12-26T11:22:07.000Z',
  },
  {
    id: 'recGRJpB99aQNqeAb',
    fields: {
      raceNumber: 1268,
      paths:
        '[[[238,443],[272,437],[239,42],[222,12],[207,18],[230,170]],[[305,254],[489,322],[504,295],[429,117],[326,32],[301,43],[265,54],[254,63],[273,82],[300,88]],[[143,483],[36,420],[61,224],[133,132]],[[168,441],[217,363],[189,216],[260,103],[176,64]],[[326,428],[317,449],[317,466],[139,551],[20,389],[247,148],[324,192]],[[229,410],[196,381],[191,246],[182,193],[33,173],[48,11],[217,21],[230,70],[223,79]],[[177,298],[209,317],[343,214],[246,98],[189,134],[169,74]],[[317,558],[281,525],[216,486],[202,490],[120,403],[277,283],[322,245],[250,175],[310,149]],[[214,393],[397,331],[272,53],[209,78]],[[274,455],[179,415],[59,325],[40,246],[90,208],[267,59]]]',
      times: '[8381,12890,8580,8069,9991,13604,7646,12573,5776,8213]',
      correct: '[true,true,true,false,false,false,true,false,false,true]',
      score: '5',
      time: 95723,
      started: true,
      name: 'Kate McLuckie',
    },
    createdTime: '2020-12-26T11:13:14.000Z',
  },
  {
    id: 'recMGZJkYuvYZfEEl',
    fields: {
      raceNumber: 1279,
      paths:
        '[[[238,443],[257,396],[245,81],[221,9],[204,15],[233,173]],[[305,254],[38,196],[43,159],[88,95],[183,36],[217,71],[304,91]],[[143,483],[68,409],[60,231],[137,133]],[[168,441],[217,369],[191,219],[262,109],[172,62]],[[326,428],[354,442],[447,381],[397,56],[308,28],[253,148],[321,192]],[[229,410],[317,362],[389,213],[403,39],[224,27],[226,75]],[[177,298],[144,318],[136,305],[60,336],[24,271],[178,139],[173,72]],[[317,558],[232,492],[206,496],[126,419],[320,248],[259,181],[304,145]],[[214,393],[274,399],[384,320],[267,56],[214,82]],[[274,455],[59,324],[34,257],[271,56]]]',
      times: '[12119,16124,15564,12943,15758,14048,15943,17273,11681,14786]',
      correct: '[true,true,true,false,true,true,false,true,false,true]',
      score: '7',
      time: 146239,
      started: true,
      name: 'Glen Richardson',
    },
    createdTime: '2020-12-26T11:22:07.000Z',
  },
  {
    id: 'recU8EVtYeFcPoVio',
    fields: {
      raceNumber: 1301,
      paths:
        '[[[238,443],[256,374],[254,123],[216,8],[206,25],[232,176]],[[305,254],[491,316],[463,182],[373,74],[299,44],[304,69],[303,90]],[[143,483],[309,262],[146,135]],[[168,441],[208,372],[200,219],[261,114],[188,65],[176,64]],[[326,428],[394,399],[444,384],[398,56],[302,35],[261,144],[323,194]],[[229,410],[308,363],[383,216],[393,29],[287,28],[235,28],[221,84]],[[177,298],[62,326],[28,283],[55,255],[178,135],[172,74]],[[317,558],[229,495],[132,433],[155,403],[312,252],[264,178],[298,149],[305,151]],[[214,393],[270,384],[312,374],[379,315],[266,60],[213,77]],[[274,455],[193,421],[45,308],[40,248],[99,197],[268,60]]]',
      times: '[6696,9921,6856,8001,10920,10568,14824,10287,8248,10655]',
      correct: '[true,true,false,false,true,true,false,true,false,true]',
      score: '6',
      time: 96976,
      started: true,
      name: 'Sebastian Ordoñez',
    },
    createdTime: '2020-12-26T11:22:07.000Z',
  },
  {
    id: 'recZf2ZB3IPyPSftk',
    fields: {
      raceNumber: 1315,
      paths:
        '[[[238,443],[266,428],[265,300],[233,64],[219,11],[209,13],[212,48],[231,175]],[[305,254],[48,196],[36,168],[60,128],[150,52],[198,45],[214,60],[243,59],[257,80],[304,93]],[[143,483],[312,252],[147,134]],[[168,441],[220,372],[191,219],[266,108],[173,64]],[[326,428],[347,435],[353,446],[404,415],[449,391],[415,155],[399,54],[307,33],[249,142],[331,194]],[[229,410],[308,379],[341,325],[395,149],[404,46],[224,24],[227,78]],[[177,298],[150,323],[133,305],[89,325],[58,331],[26,276],[187,137],[173,75]],[[317,558],[229,492],[174,484],[127,422],[227,348],[314,256],[300,224],[258,181],[289,148],[309,154]],[[214,393],[48,127],[117,88],[196,60],[213,60],[215,85]],[[274,455],[154,393],[56,307],[40,280],[46,229],[130,172],[222,104],[277,56]]]',
      times: '[8732,7894,2856,6410,11127,7513,6415,11111,7472,6412]',
      correct: '[true,true,false,false,true,true,false,true,false,true]',
      score: '6',
      time: 75942,
      started: true,
      name: 'Harry McMurtrie',
    },
    createdTime: '2020-12-26T11:22:07.000Z',
  },
  {
    id: 'recESxBqwVuEyFGxA',
    fields: {
      raceNumber: 1317,
      paths:
        '[[[238,443],[258,428],[216,11],[235,172]],[[305,254],[503,320],[399,122],[313,47],[301,48],[307,85],[254,58],[304,55],[256,58],[310,84],[303,53],[258,59],[261,72],[307,84],[309,88]],[[143,483],[25,414],[75,202],[140,130]],[[168,441],[219,377],[32,239],[172,57],[172,68]],[[326,428],[348,441],[448,396],[392,50],[306,33],[250,149],[324,199]],[[229,410],[312,371],[399,142],[398,28],[230,24],[225,77]],[[177,298],[201,321],[333,217],[235,101],[193,122],[169,73]],[[317,558],[122,406],[36,192],[260,167],[303,143]],[[214,393],[389,303],[274,43],[217,82]],[[274,455],[38,246],[272,58]]]',
      times: '[4377,14119,5411,5219,7605,6839,6098,6336,5052,4647]',
      correct: '[true,false,true,false,true,true,true,false,false,true]',
      score: '6',
      time: 65703,
      started: true,
      name: 'Kirsten Robertson',
    },
    createdTime: '2020-12-26T11:22:07.000Z',
  },
  {
    id: 'recenhiyYFXQmOaxz',
    fields: {
      raceNumber: 1333,
      paths:
        '[[[238,443],[235,429],[252,228],[224,16],[208,16],[231,166]],[[305,254],[298,253],[34,194],[70,105],[175,41],[214,59],[244,80],[306,92]],[[143,483],[141,477],[311,256],[145,138]],[[168,441],[178,434],[217,369],[251,124],[258,104],[171,57]],[[326,428],[322,456],[144,556],[26,384],[249,146],[321,189]],[[229,410],[228,406],[316,372],[403,194],[403,30],[227,19],[227,76]],[[177,298],[180,300],[203,326],[342,212],[247,101],[183,131],[168,73]],[[317,558],[310,542],[227,487],[163,465],[131,404],[323,249],[247,168],[301,144]],[[214,393],[211,404],[161,317],[193,298],[219,304],[222,292],[171,188],[121,82],[207,37],[212,84]],[[274,455],[268,442],[459,357],[440,160],[445,124],[423,120],[320,169],[273,46],[272,57]]]',
      times: '[8140,11880,6417,10209,8641,9485,9855,15471,15544,17111]',
      correct: '[true,true,false,true,false,true,true,true,true,false]',
      score: '7',
      time: 112753,
      started: true,
      name: 'Judith Bell',
    },
    createdTime: '2020-12-26T11:22:07.000Z',
  },
  {
    id: 'recxysySU0MmIyArb',
    fields: {
      raceNumber: 1353,
      paths:
        '[[[238,443],[90,400],[35,216],[33,128],[231,174]],[[305,254],[495,323],[450,163],[340,53],[296,47],[295,57],[311,73],[306,83],[305,95]],[[143,483],[30,415],[71,215],[140,129]],[[168,441],[219,375],[253,123],[263,111],[187,61],[168,67]],[[326,428],[353,442],[451,384],[397,58],[306,25],[259,147],[321,190]],[[229,410],[187,331],[32,260],[46,8],[219,25],[222,64],[225,76]],[[177,298],[201,318],[333,220],[282,164],[235,192],[180,127],[173,67]],[[317,558],[563,296],[426,166],[323,243],[258,180],[304,138],[309,147]],[[214,393],[280,394],[377,313],[267,58],[213,75]],[[274,455],[57,322],[50,235],[202,127],[276,57]]]',
      times: '[10672,15920,12160,14688,23913,19584,21119,24112,13952,22761]',
      correct: '[false,true,true,true,true,false,false,false,false,true]',
      score: '4',
      time: 178881,
      started: true,
      name: 'Heather Walton',
    },
    createdTime: '2020-12-26T11:22:07.000Z',
  },
  {
    id: 'recgRcSEz2RCT91nK',
    fields: {
      raceNumber: 1366,
      paths:
        '[[[238,443],[85,397],[33,220],[24,128],[49,125],[237,172]],[[305,254],[48,197],[35,174],[95,91],[162,50],[205,41],[213,75],[298,87],[303,92]],[[143,483],[145,486],[309,257],[149,136]],[[168,441],[215,370],[260,108],[195,62],[174,66]],[[326,428],[378,407],[443,392],[446,307],[397,58],[307,27],[253,141],[320,191]],[[229,410],[306,375],[394,183],[409,37],[222,22],[221,77]],[[177,298],[150,318],[133,301],[62,334],[26,279],[69,231],[186,134],[173,76]],[[317,558],[228,489],[194,489],[142,434],[135,412],[199,373],[324,246],[259,178],[295,141],[312,150]],[[214,393],[170,313],[196,297],[220,303],[220,288],[208,278],[135,82],[201,49],[216,74]],[[274,455],[174,401],[43,302],[42,242],[202,120],[268,54]]]',
      times: '[13973,18480,6524,11738,25976,9936,15192,19954,17816,14556]',
      correct: '[false,true,false,true,true,true,false,true,true,true]',
      score: '6.5',
      time: 154145,
      started: true,
      name: 'Malcolm Aldridge',
    },
    createdTime: '2020-12-26T11:22:07.000Z',
  },
  {
    id: 'recUw0MUxScsFIZqh',
    fields: {
      raceNumber: 1369,
      paths:
        '[[[238,443],[267,382],[228,8],[204,22],[236,172]],[[305,254],[487,323],[521,277],[483,231],[364,71],[319,54],[305,43],[296,50],[259,59],[255,64],[305,99]],[[143,483],[40,415],[56,235],[144,141]],[[168,441],[227,365],[191,210],[260,109],[165,70]],[[326,428],[404,399],[447,387],[393,53],[305,27],[253,147],[331,195]],[[229,410],[335,313],[407,195],[399,70],[388,34],[295,21],[220,19],[223,80]],[[177,298],[210,326],[346,208],[247,97],[184,146],[175,66]],[[317,558],[572,288],[425,159],[316,244],[239,175],[306,145]],[[214,393],[29,111],[211,44],[216,87]],[[274,455],[471,379],[448,323],[432,201],[452,135],[427,115],[355,175],[293,173],[291,113],[272,52]]]',
      times: '[5727,12616,5467,5804,11050,9905,8293,14446,6244,11330]',
      correct: '[true,true,true,false,true,true,true,false,false,false]',
      score: '6',
      time: 90882,
      started: true,
      name: 'Hannah Gray',
    },
    createdTime: '2020-12-26T11:15:42.000Z',
  },
  {
    id: 'recLMl6hFaKJDzKZe',
    fields: {
      raceNumber: 1398,
      paths:
        '[[[238,443],[241,443],[271,350],[224,15],[210,14],[232,176]],[[305,254],[302,255],[41,193],[38,165],[145,54],[203,40],[216,73],[303,91]],[[143,483],[145,478],[314,257],[145,131]],[[168,441],[173,436],[216,370],[192,217],[265,110],[198,63],[177,63]],[[326,428],[328,425],[354,439],[446,386],[418,183],[397,59],[310,24],[257,133],[328,188]],[[229,410],[229,412],[303,374],[390,184],[400,43],[225,28],[224,78]],[[177,298],[177,295],[147,318],[133,305],[66,333],[26,275],[181,143],[174,70]],[[317,558],[312,552],[556,301],[434,157],[457,117],[398,48],[307,145]],[[214,393],[210,392],[46,120],[201,50],[216,82]],[[274,455],[267,442],[471,369],[458,343],[446,332],[437,132],[427,120],[394,140],[368,167],[311,165],[291,125],[282,71],[274,58]]]',
      times: '[9047,11984,6184,12216,23575,14970,15623,25714,8656,22295]',
      correct: '[true,true,false,false,true,true,false,false,false,false]',
      score: '3.5',
      time: 150264,
      started: true,
      name: 'Stanimira Dimitrova',
    },
    createdTime: '2020-12-26T11:22:07.000Z',
  },
  {
    id: 'recgoWLC1ZeTF9Gij',
    fields: {
      raceNumber: 1422,
      paths:
        '[[[238,443],[240,425],[252,408],[259,378],[252,249],[251,173],[242,92],[233,45],[220,10],[212,16],[217,49],[223,108],[226,156],[233,172]],[[305,254],[308,251],[488,315],[495,302],[467,202],[431,131],[386,82],[345,57],[317,47],[298,48],[301,61],[284,60],[266,57],[252,62],[255,71],[272,81],[286,85],[297,85],[305,94]],[[143,483],[306,276],[306,250],[210,174],[150,124],[143,134]],[[168,441],[175,436],[201,397],[211,365],[209,287],[195,225],[197,204],[241,140],[261,113],[253,130],[228,83],[189,63],[171,64]],[[326,428],[332,429],[357,416],[375,405],[380,393],[397,387],[414,402],[436,395],[447,385],[439,281],[416,155],[396,65],[388,52],[344,38],[308,31],[302,34],[287,68],[272,104],[257,135],[257,151],[283,166],[311,182],[323,190]],[[229,410],[232,405],[306,369],[332,322],[366,246],[384,214],[404,150],[411,55],[408,32],[350,27],[293,25],[234,25],[228,36],[228,58],[226,79]],[[177,298],[183,299],[205,324],[282,271],[330,223],[325,196],[290,160],[267,175],[235,191],[211,167],[193,143],[174,113],[173,91],[171,70]],[[317,558],[304,543],[241,492],[194,482],[156,438],[137,414],[183,379],[240,329],[286,282],[318,249],[314,237],[286,207],[245,176],[270,160],[295,141],[309,145]],[[214,393],[205,388],[170,327],[173,306],[186,299],[204,301],[215,304],[221,287],[205,275],[197,257],[173,198],[158,142],[139,85],[141,63],[182,56],[206,56],[213,64],[216,77]],[[274,455],[284,442],[363,418],[423,400],[457,376],[462,348],[442,343],[386,347],[320,323],[278,305],[254,295],[258,274],[278,230],[304,188],[303,157],[292,120],[286,75],[273,55]]]',
      times: '[12217,21536,14352,14496,21377,19343,14648,19265,13417,14913]',
      correct: '[true,true,false,false,true,true,false,true,true,false]',
      score: '5',
      time: 165564,
      started: true,
      name: 'Elias Schafer',
    },
    createdTime: '2020-12-23T20:59:21.000Z',
  },
  {
    id: 'recmjBqcwOkrkpFB5',
    fields: {
      raceNumber: 1437,
      paths:
        '[[[238,443],[266,397],[234,22],[219,14],[205,19],[230,174]],[[305,254],[37,188],[187,38],[226,51],[262,73],[302,94]],[[143,483],[314,261],[142,135]],[[168,441],[219,371],[190,219],[261,115],[258,100],[169,62]],[[326,428],[320,458],[152,553],[24,390],[253,147],[323,195]],[[229,410],[315,379],[396,174],[407,46],[229,25],[224,74]],[[177,298],[198,320],[328,215],[237,107],[189,137],[169,75]],[[317,558],[232,488],[182,475],[127,420],[325,250],[253,181],[315,140],[310,145]],[[214,393],[270,397],[387,320],[270,50],[217,75]],[[274,455],[48,316],[47,240],[204,116],[265,57]]]',
      times: '[10600,17027,5551,10426,11443,11659,20962,15483,10899,9941]',
      correct: '[true,false,false,false,false,true,true,true,false,true]',
      score: '4.5',
      time: 123991,
      started: true,
      name: 'Alison Fryer',
    },
    createdTime: '2020-12-26T11:22:07.000Z',
  },
  {
    id: 'recl8cOTjhYpjoqiu',
    fields: {
      raceNumber: 1443,
      paths:
        '[[[238,443],[255,384],[220,11],[205,19],[233,170]],[[305,254],[37,179],[200,38],[213,74],[304,90]],[[143,483],[312,256],[141,138]],[[168,441],[222,370],[209,193],[264,106],[181,60],[172,63]],[[326,428],[451,383],[440,253],[395,55],[308,25],[256,145],[329,192]],[[229,410],[307,370],[402,184],[415,41],[225,26],[224,81]],[[177,298],[146,319],[66,333],[19,276],[183,135],[172,67]],[[317,558],[228,488],[194,485],[133,417],[213,349],[318,243],[256,179],[301,145]],[[214,393],[46,114],[208,51],[217,80]],[[274,455],[80,337],[37,269],[57,229],[268,54]]]',
      times: '[5692,11252,5550,8991,11682,6729,14746,11769,6723,12846]',
      correct: '[true,true,false,false,true,true,false,true,false,true]',
      score: '6',
      time: 95980,
      started: true,
      name: 'Cornelia Eckardt',
    },
    createdTime: '2020-12-26T11:22:07.000Z',
  },
  {
    id: 'recl25Nt8JDwBk4Ch',
    fields: {
      raceNumber: 1450,
      paths:
        '[[[238,443],[242,451],[267,338],[265,223],[252,117],[239,33],[205,9],[197,54],[200,96],[211,135],[234,178]],[[305,254],[305,263],[201,252],[55,222],[22,182],[103,75],[179,32],[249,26],[312,37],[302,52],[311,71],[310,100]],[[143,483],[138,488],[101,474],[43,437],[36,380],[37,295],[49,237],[70,213],[97,176],[116,162],[138,140]],[[168,441],[171,446],[194,406],[220,372],[207,305],[200,245],[199,200],[234,146],[266,114],[229,86],[201,68],[164,70]],[[326,428],[326,428],[316,462],[307,488],[235,524],[159,574],[108,519],[57,452],[28,402],[71,331],[116,285],[185,215],[227,169],[274,162],[321,194]],[[229,410],[229,413],[313,377],[328,322],[384,300],[397,216],[401,129],[411,35],[310,24],[235,20],[228,66],[224,80]],[[177,298],[176,298],[151,324],[117,325],[67,345],[21,301],[49,252],[110,203],[154,166],[183,142],[172,113],[156,93],[173,74]],[[317,558],[315,559],[289,544],[246,513],[216,497],[173,479],[148,455],[120,425],[172,395],[220,353],[267,315],[300,285],[330,255],[249,177],[283,142],[314,144]],[[214,393],[212,406],[257,399],[336,358],[382,332],[368,281],[353,218],[335,164],[308,114],[284,72],[273,39],[232,54],[217,86]],[[274,455],[247,438],[210,426],[161,408],[116,381],[77,345],[36,300],[42,244],[78,217],[125,188],[149,161],[177,137],[200,116],[220,99],[237,83],[251,70],[275,61]]]',
      times: '[13547,12821,14466,10582,15646,12253,15421,19093,14412,11547]',
      correct: '[true,true,false,false,false,true,false,true,false,true]',
      score: '5',
      time: 139788,
      started: true,
      name: 'Janette McHendry',
    },
    createdTime: '2020-12-26T11:22:07.000Z',
  },
  {
    id: 'rec0T6qp8l3r27nqE',
    fields: {
      raceNumber: 1451,
      paths:
        '[[[238,443],[238,436],[84,397],[25,213],[37,129],[236,171]],[[305,254],[304,259],[42,184],[42,153],[172,46],[206,45],[306,95]],[[143,483],[140,478],[79,391],[76,321],[69,215],[139,134]],[[168,441],[174,427],[216,364],[198,220],[262,107],[171,62]],[[326,428],[332,423],[371,397],[449,384],[394,53],[311,33],[256,154],[325,192]],[[229,410],[228,406],[28,253],[49,10],[223,27],[220,76]],[[177,298],[177,296],[144,313],[61,326],[26,283],[42,255],[179,135],[174,69]],[[317,558],[320,559],[233,495],[188,481],[132,412],[219,352],[320,247],[261,174],[303,146]],[[214,393],[209,391],[54,120],[206,52],[214,85]],[[274,455],[280,455],[166,394],[40,293],[47,235],[274,55]]]',
      times: '[6608,7257,3872,5352,11344,7527,7472,7176,5200,7456]',
      correct: '[false,true,true,false,true,false,false,true,false,true]',
      score: '5',
      time: 69264,
      started: true,
      name: 'Joe Sunley',
    },
    createdTime: '2020-12-26T11:22:07.000Z',
  },
  {
    id: 'recbReAFo9kfL1Lg8',
    fields: {
      raceNumber: 1502,
      paths:
        '[[[238,443],[257,394],[250,144],[213,6],[205,20],[227,176]],[[305,254],[37,179],[100,92],[198,38],[237,56],[301,93]],[[143,483],[78,384],[69,220],[142,137]],[[168,441],[215,371],[261,254],[253,125],[259,108],[167,65]],[[326,428],[443,395],[396,56],[312,29],[251,146],[319,194]],[[229,410],[295,377],[389,183],[402,40],[224,27],[224,77]],[[177,298],[142,313],[68,331],[32,275],[182,135],[173,74]],[[317,558],[565,300],[423,171],[320,238],[255,173],[302,148]],[[214,393],[274,389],[381,313],[269,55],[218,81]],[[274,455],[47,315],[46,237],[191,131],[275,59]]]',
      times: '[10001,9180,6913,10616,11500,12290,8462,14280,12156,9116]',
      correct: '[true,true,true,true,true,true,false,false,false,true]',
      score: '7',
      time: 104514,
      started: true,
      name: 'Kirsten Strain',
    },
    createdTime: '2020-12-26T11:22:07.000Z',
  },
  {
    id: 'rec2uTJqz6QRkhh95',
    fields: {
      raceNumber: 1508,
      paths:
        '[[[238,443],[259,380],[232,20],[212,16],[235,167]],[[305,254],[52,196],[35,171],[208,43],[217,69],[304,93]],[[143,483],[79,387],[72,210],[138,140]],[[168,441],[214,369],[267,111],[180,59],[173,66]],[[326,428],[385,408],[448,393],[400,62],[312,31],[254,139],[326,190]],[[229,410],[296,380],[389,190],[406,38],[229,27],[224,74]],[[177,298],[137,312],[62,325],[28,280],[180,145],[173,69]],[[317,558],[240,496],[197,486],[138,403],[318,255],[265,175],[303,149]],[[214,393],[318,375],[380,319],[272,64],[210,81]],[[274,455],[143,380],[44,291],[51,240],[273,54]]]',
      times: '[6153,9812,7763,6963,12476,9203,9889,11700,9113,9931]',
      correct: '[true,true,true,true,true,true,false,true,false,true]',
      score: '8',
      time: 93003,
      started: true,
      name: 'David Robertson',
    },
    createdTime: '2020-12-26T11:22:07.000Z',
  },
  {
    id: 'recQZbrhTIgMTx3BG',
    fields: {
      raceNumber: 1509,
      paths:
        '[[[238,443],[243,444],[272,426],[258,227],[235,14],[207,18],[227,169]],[[305,254],[24,184],[80,76],[275,25],[297,46],[304,95]],[[143,483],[39,423],[135,292],[56,228],[135,131]],[[168,441],[218,375],[293,275],[252,229],[251,126],[248,82],[179,58],[169,61]],[[326,428],[325,472],[151,562],[27,383],[249,144],[323,194]],[[229,410],[326,319],[407,146],[413,45],[246,19],[225,37],[223,78]],[[177,298],[207,324],[341,211],[248,100],[182,132],[173,70]],[[317,558],[234,488],[158,457],[127,417],[322,253],[259,179],[305,146]],[[214,393],[38,122],[178,54],[215,81]],[[274,455],[32,278],[95,204],[200,123],[273,51]]]',
      times: '[21715,14462,12808,21772,15876,18336,14223,16303,8939,9672]',
      correct: '[true,true,true,true,false,true,true,true,false,true]',
      score: '7',
      time: 154106,
      started: true,
      name: 'Hanne Robertson',
    },
    createdTime: '2020-12-26T11:22:07.000Z',
  },
  {
    id: 'reckcl94M8MGPVcg9',
    fields: {
      raceNumber: 1515,
      paths:
        '[[[238,443],[229,441],[260,386],[258,330],[248,242],[225,165],[223,188],[236,162],[230,171]],[[305,254],[300,259],[223,246],[144,232],[51,219],[5,151],[67,91],[157,21],[273,27],[293,32],[275,80],[285,89],[236,61],[307,106],[302,115],[296,92],[295,90],[228,53],[239,47],[297,85],[290,100],[305,95]],[[143,483],[135,486],[190,404],[245,335],[293,284],[308,259],[213,185],[140,129]],[[168,441],[153,443],[190,411],[210,380],[209,369],[123,300],[185,201],[208,189],[232,136],[254,111],[249,85],[159,51],[166,65]],[[326,428],[314,419],[319,464],[247,505],[175,541],[134,576],[70,492],[14,400],[89,303],[181,200],[231,145],[326,201]],[[229,410],[216,396],[291,372],[339,402],[373,293],[395,177],[407,32],[318,6],[292,32],[282,64],[287,24],[240,13],[210,13],[218,74]],[[177,298],[164,295],[209,328],[234,291],[320,221],[331,197],[238,99],[186,145],[146,86],[161,71],[156,70],[170,67]],[[317,558],[304,561],[217,488],[175,481],[113,428],[205,365],[267,289],[310,253],[234,170],[277,134],[299,143],[296,152],[303,155]],[[214,393],[206,395],[149,314],[54,191],[25,113],[96,99],[193,51],[212,80]],[[274,455],[272,445],[370,424],[442,379],[466,363],[433,264],[425,176],[430,108],[357,165],[296,173],[284,110],[262,48],[261,66],[265,54]]]',
      times: '[7645,20594,8303,14908,10895,14302,13557,13342,7796,11414]',
      correct: '[false,false,false,false,false,true,true,true,false,false]',
      score: '3',
      time: 122756,
      started: true,
      name: 'Ann Robertson',
    },
    createdTime: '2020-12-26T11:22:07.000Z',
  },
  {
    id: 'recc9qPfi5bvnVv1C',
    fields: {
      raceNumber: 1525,
      paths:
        '[[[238,443],[75,396],[34,230],[25,126],[237,173]],[[305,254],[40,199],[37,181],[99,87],[197,40],[206,49],[302,61],[308,70],[305,93]],[[143,483],[77,389],[108,335],[64,217],[112,164],[139,129]],[[168,441],[211,372],[188,222],[263,117],[182,62],[174,64]],[[326,428],[349,439],[451,389],[398,56],[307,31],[255,146],[328,191]],[[229,410],[314,371],[330,328],[388,209],[403,40],[224,21],[221,74]],[[177,298],[204,323],[331,224],[242,105],[188,128],[170,76]],[[317,558],[208,485],[129,422],[217,360],[321,253],[261,186],[308,139],[307,146]],[[214,393],[171,317],[194,298],[221,305],[190,237],[134,86],[201,53],[218,80]],[[274,455],[418,411],[464,351],[444,323],[438,138],[430,110],[365,169],[291,140],[275,54]]]',
      times: '[14223,21776,15580,13032,15140,14973,15442,22959,13037,16465]',
      correct: '[false,true,true,false,true,true,true,true,true,false]',
      score: '6',
      time: 162627,
      started: true,
      name: 'Angela Darley',
    },
    createdTime: '2020-12-26T11:22:07.000Z',
  },
  {
    id: 'recvDNc7tmIMtPtRL',
    fields: {
      raceNumber: 1526,
      paths:
        '[[[238,443],[240,436],[267,386],[255,265],[254,205],[240,172]],[[305,254],[310,261],[460,302],[506,311],[495,222],[450,148],[419,106],[347,48],[301,45],[298,58],[280,52],[266,59],[256,76],[276,80],[295,88],[305,96]],[[143,483],[134,476],[55,432],[35,386],[49,342],[29,247],[35,214],[52,191],[87,189],[85,146],[91,136],[131,108],[143,133]],[[168,441],[189,411],[211,379],[197,316],[196,212],[229,157],[249,126],[248,99],[185,57],[174,67]],[[326,428],[318,446],[299,485],[230,516],[148,555],[55,432],[33,385],[105,300],[172,228],[243,155],[263,158],[303,180],[327,197]],[[229,410],[227,408],[189,380],[187,319],[183,266],[194,195],[291,194],[380,214],[398,211],[407,93],[407,28],[305,21],[237,27],[225,28],[226,78]],[[177,298],[175,300],[194,318],[197,332],[139,372],[103,394],[63,336],[35,289],[37,258],[108,210],[170,144],[185,122],[176,78]],[[317,558],[290,540],[224,478],[200,494],[137,428],[165,398],[221,352],[264,308],[324,251],[281,208],[253,177],[306,144]],[[214,393],[215,400],[162,336],[193,298],[224,305],[204,280],[170,177],[135,111],[202,56],[227,52],[215,80]],[[274,455],[334,428],[435,396],[476,357],[445,317],[439,116],[413,124],[305,156],[277,77],[276,60]]]',
      times: '[6702,22115,17034,13114,19140,22182,21337,19031,18188,16061]',
      correct: '[false,true,false,false,false,false,false,true,true,false]',
      score: '2.5',
      time: 174904,
      started: true,
      name: 'Jane Hunter',
    },
    createdTime: '2020-12-26T11:22:07.000Z',
  },
  {
    id: 'rec3xSAxDWWdd2veU',
    fields: {
      raceNumber: 1556,
      paths:
        '[[[238,443],[255,443],[274,383],[267,304],[266,257],[265,232],[242,184],[266,97],[232,34],[209,9],[206,18],[190,101],[188,165],[225,174],[230,174]],[[305,254],[372,272],[441,297],[497,314],[494,265],[486,186],[455,108],[389,67],[351,59],[314,54],[295,47],[294,66],[303,91]],[[143,483],[89,458],[46,426],[109,341],[141,295],[78,247],[54,238],[32,203],[81,122],[105,113],[131,103],[143,119],[144,128]],[[168,441],[245,351],[289,274],[255,245],[202,210],[227,155],[255,124],[270,110],[253,98],[202,69],[184,65],[172,70]],[[326,428],[374,407],[386,393],[414,400],[435,396],[429,306],[418,291],[396,275],[377,243],[357,224],[334,210],[328,200]],[[229,410],[182,381],[198,201],[294,205],[396,206],[409,109],[408,47],[393,30],[313,20],[254,17],[229,13],[220,24],[225,56],[217,98],[229,90],[227,86]],[[177,298],[157,320],[137,300],[116,313],[42,331],[32,292],[33,259],[99,216],[138,184],[171,158],[188,128],[174,95],[165,79],[165,76]],[[317,558],[206,492],[152,443],[130,423],[172,387],[283,291],[315,249],[270,197],[264,158],[282,145],[297,152],[304,152]],[[214,393],[151,325],[172,304],[202,305],[215,309],[223,285],[185,196],[174,166],[139,104],[144,72],[175,72],[191,59],[220,78]],[[274,455],[71,327],[38,255],[66,222],[157,154],[200,110],[268,62]]]',
      times: '[12801,12592,11641,13993,24240,27616,16232,18742,15856,12039]',
      correct: '[false,true,false,true,false,false,false,true,true,true]',
      score: '5',
      time: 165752,
      started: true,
      name: 'Amanda Bailey',
    },
    createdTime: '2020-12-26T11:22:07.000Z',
  },
  {
    id: 'recYF7Vpem4TcTsV3',
    fields: {
      raceNumber: 1564,
      paths:
        '[[[238,443],[235,435],[265,379],[225,9],[207,14],[233,172]],[[305,254],[299,254],[27,175],[83,78],[203,36],[218,72],[302,89]],[[143,483],[146,469],[313,253],[141,135]],[[168,441],[222,366],[29,233],[150,60],[171,60]],[[326,428],[405,390],[453,393],[393,56],[303,19],[247,145],[321,190]],[[229,410],[182,342],[193,182],[36,152],[45,9],[226,15],[221,75]],[[177,298],[148,318],[127,300],[63,332],[26,263],[182,138],[170,69]],[[317,558],[223,484],[199,493],[132,413],[263,312],[318,240],[257,173],[299,138],[309,149]],[[214,393],[389,317],[352,232],[268,42],[217,78]],[[274,455],[117,361],[38,282],[67,226],[269,50]]]',
      times: '[10215,12542,5589,17442,26796,13204,15230,17705,12256,13608]',
      correct: '[true,true,false,false,true,false,false,true,false,true]',
      score: '4.5',
      time: 144587,
      started: true,
      name: 'Steve McLean',
    },
    createdTime: '2020-12-26T11:22:07.000Z',
  },
  {
    id: 'rec7NBVMmcelIAES1',
    fields: {
      raceNumber: 1569,
      paths:
        '[[[238,443],[241,444],[76,398],[29,130],[237,183],[228,158],[237,176]],[[305,254],[309,253],[19,185],[51,142],[197,24],[215,65],[305,94]],[[143,483],[144,476],[79,376],[78,207],[139,142]],[[168,441],[171,433],[216,374],[271,111],[165,69]],[[326,428],[329,435],[402,399],[432,300],[437,388],[451,371],[388,50],[309,31],[257,155],[331,193]],[[229,410],[229,407],[317,355],[410,176],[396,25],[219,24],[223,67],[226,80]],[[177,298],[176,296],[203,318],[333,217],[245,109],[191,124],[164,91],[169,69]],[[317,558],[316,556],[136,437],[138,403],[236,334],[319,243],[262,174],[303,145]],[[214,393],[212,400],[335,354],[377,311],[269,54],[222,74],[213,88]],[[274,455],[275,451],[456,388],[461,341],[259,310],[187,248],[203,124],[266,52]]]',
      times: '[6617,6681,3768,4920,9351,7377,7568,9599,6990,15016]',
      correct: '[false,true,true,true,false,true,true,true,false,false]',
      score: '6',
      time: 77887,
      started: true,
      name: 'Franz Glaner',
    },
    createdTime: '2020-12-26T11:22:07.000Z',
  },
  {
    id: 'rec7ePtDLNU1S2tnU',
    fields: {
      raceNumber: 1575,
      paths:
        '[[[238,443],[80,406],[26,217],[27,127],[234,171]],[[305,254],[33,193],[133,56],[205,43],[215,52],[308,95]],[[143,483],[30,407],[65,218],[141,136]],[[168,441],[217,373],[263,106],[175,64]],[[326,428],[361,440],[449,389],[399,57],[311,35],[247,144],[328,194]],[[229,410],[320,349],[410,179],[411,39],[227,20],[227,74]],[[177,298],[150,318],[63,331],[23,282],[185,138],[177,78],[174,73]],[[317,558],[132,416],[322,251],[256,176],[309,156]],[[214,393],[173,318],[205,300],[223,296],[222,287],[123,86],[208,54],[212,80]],[[274,455],[471,371],[458,346],[250,303],[311,170],[275,54]]]',
      times: '[12802,10474,6852,10474,21094,14873,20498,11587,17831,15165]',
      correct: '[false,true,true,true,true,true,false,true,true,false]',
      score: '6.5',
      time: 141650,
      started: true,
      name: 'Iain Shepherd',
    },
    createdTime: '2020-12-26T11:22:07.000Z',
  },
  {
    id: 'reciwEpY4tUfU79X6',
    fields: {
      raceNumber: 1578,
      paths:
        '[[[238,443],[118,410],[70,375],[39,222],[30,129],[230,174]],[[305,254],[490,322],[478,240],[400,86],[296,39],[293,55],[313,67],[298,78],[303,95]],[[143,483],[75,379],[128,304],[67,226],[138,135]],[[168,441],[215,365],[190,218],[262,106],[179,59],[174,63]],[[326,428],[352,443],[453,377],[396,58],[300,28],[253,141],[321,189]],[[229,410],[313,362],[342,321],[390,208],[405,44],[229,25],[223,70]],[[177,298],[148,318],[129,303],[54,326],[32,269],[184,130],[171,68]],[[317,558],[233,483],[202,490],[120,403],[82,332],[173,277],[155,173],[245,179],[299,137],[303,144]],[[214,393],[40,110],[150,73],[205,53],[215,79]],[[274,455],[341,429],[444,390],[459,342],[450,342],[437,167],[425,122],[402,128],[343,169],[299,144],[273,50]]]',
      times: '[8376,15392,9312,8016,12073,10848,10464,17762,16480,18424]',
      correct: '[false,true,true,false,true,true,false,false,false,false]',
      score: '4',
      time: 127147,
      started: true,
      name: 'Sue Bett',
    },
    createdTime: '2020-12-26T11:22:07.000Z',
  },
  {
    id: 'recqbAwHuqf841UZY',
    fields: {
      raceNumber: 1583,
      paths:
        '[[[238,443],[261,390],[263,217],[231,18],[223,6],[203,16],[233,173]],[[305,254],[32,192],[59,122],[202,32],[213,54],[291,58],[310,66],[250,58],[250,71],[266,78],[308,93]],[[143,483],[313,262],[184,138],[139,130]],[[168,441],[221,369],[250,122],[262,105],[199,53],[171,62]],[[326,428],[345,426],[357,442],[451,386],[429,213],[403,58],[296,26],[251,153],[327,192]],[[229,410],[311,382],[395,179],[407,35],[227,24],[218,74]],[[177,298],[200,323],[334,224],[246,98],[179,126],[171,74]],[[317,558],[241,478],[205,496],[125,411],[202,373],[323,244],[249,171],[293,138],[307,152]],[[214,393],[78,189],[43,108],[144,77],[219,51],[215,78]],[[274,455],[197,416],[66,333],[33,266],[96,205],[197,126],[272,50]]]',
      times: '[7433,13120,4563,7076,11551,7701,8018,11576,6350,7373]',
      correct: '[true,true,false,true,true,true,true,true,false,true]',
      score: '8',
      time: 84761,
      started: true,
      name: 'Helen Nisbet',
    },
    createdTime: '2020-12-26T11:22:07.000Z',
  },
  {
    id: 'recZR7bIt3AtuAV9q',
    fields: {
      raceNumber: 1586,
      paths:
        '[[[238,443],[184,423],[96,411],[34,218],[25,124],[237,173]],[[305,254],[499,325],[455,175],[403,94],[313,43],[291,50],[259,67],[300,92]],[[143,483],[317,251],[146,133]],[[168,441],[213,372],[37,234],[158,62],[172,65]],[[326,428],[316,467],[156,559],[30,398],[246,150],[323,193]],[[229,410],[317,375],[366,304],[398,106],[400,34],[229,31],[218,76]],[[177,298],[213,320],[242,105],[182,118],[169,74]],[[317,558],[235,487],[494,222],[428,168],[324,244],[259,180],[308,148]],[[214,393],[170,313],[226,293],[132,83],[209,54],[220,82]],[[274,455],[47,313],[42,254],[207,112],[269,55]]]',
      times: '[8192,11409,4312,7384,12120,9161,7000,9360,8024,9048]',
      correct: '[false,true,false,false,false,true,false,false,true,true]',
      score: '4',
      time: 86010,
      started: true,
      name: 'Rachel Kirkland',
    },
    createdTime: '2020-12-26T11:22:07.000Z',
  },
  {
    id: 'recuji5fp941gIWky',
    fields: {
      raceNumber: 1594,
      paths:
        '[[[238,443],[256,395],[258,214],[235,47],[214,11],[208,19],[233,168]],[[305,254],[50,197],[40,179],[97,84],[172,52],[191,47],[211,56],[304,97]],[[143,483],[77,390],[64,226],[141,136]],[[168,441],[206,382],[264,107],[179,62]],[[326,428],[354,440],[405,412],[452,386],[427,231],[399,52],[308,30],[255,148],[326,193]],[[229,410],[30,257],[47,8],[220,27],[220,77]],[[177,298],[63,328],[28,277],[190,149],[167,66]],[[317,558],[235,494],[203,489],[132,414],[311,249],[261,186],[313,130],[311,144]],[[214,393],[70,164],[48,128],[81,101],[206,56],[223,94],[217,83]],[[274,455],[47,313],[39,271],[52,231],[190,128],[270,56]]]',
      times: '[8352,7952,4528,4887,10304,9247,7687,14553,11376,9906]',
      correct: '[true,true,true,true,true,false,false,true,false,true]',
      score: '7',
      time: 88792,
      started: true,
      name: 'Paul Todd',
    },
    createdTime: '2020-12-26T11:22:07.000Z',
  },
  {
    id: 'recMMBowr1VdMgRNJ',
    fields: {
      raceNumber: 1606,
      paths:
        '[[[238,443],[80,399],[35,224],[33,126],[235,174]],[[305,254],[36,191],[80,99],[203,37],[212,50],[304,95]],[[143,483],[47,422],[60,229],[139,134]],[[168,441],[214,365],[264,107],[184,61],[176,65]],[[326,428],[317,461],[146,559],[35,391],[247,153],[330,193]],[[229,410],[29,255],[48,6],[224,25],[221,75]],[[177,298],[147,319],[134,303],[67,337],[24,277],[177,139],[171,74]],[[317,558],[223,484],[205,489],[137,423],[322,250],[260,179],[293,140],[305,148]],[[214,393],[167,313],[219,297],[221,287],[209,282],[132,78],[201,45],[217,79]],[[274,455],[468,370],[458,343],[443,287],[440,126],[412,123],[338,174],[297,134],[274,53]]]',
      times: '[22183,11904,17656,11440,17143,11799,11408,14032,17815,15633]',
      correct: '[false,true,true,true,false,false,false,true,true,false]',
      score: '5',
      time: 151013,
      started: true,
      name: 'Nick Lightfoot',
    },
    createdTime: '2020-12-26T11:22:07.000Z',
  },
  {
    id: 'recJakNUrI3SEFRPF',
    fields: {
      raceNumber: 1608,
      paths:
        '[[[238,443],[251,314],[250,187],[238,73],[225,19],[205,28],[215,130],[232,178]],[[305,254],[386,283],[490,319],[482,259],[447,163],[406,109],[339,61],[299,50],[302,95]],[[143,483],[203,407],[278,290],[309,254],[214,178],[146,133]],[[168,441],[215,371],[233,264],[238,205],[235,148],[252,106],[217,71],[179,62]],[[326,428],[300,390],[313,315],[319,224],[326,199]],[[229,410],[252,385],[336,363],[331,316],[364,252],[384,204],[400,146],[404,78],[400,35],[261,25],[216,41],[227,64],[225,79]],[[177,298],[203,328],[276,256],[322,210],[290,159],[231,103],[175,100],[170,73]],[[317,558],[214,489],[172,471],[132,419],[92,362],[124,412],[141,408],[184,382],[222,351],[255,313],[293,272],[318,243],[307,226],[277,196],[264,177],[310,148]],[[214,393],[162,305],[117,229],[66,159],[55,97],[166,58],[219,83]],[[274,455],[301,447],[384,429],[430,410],[458,373],[459,347],[444,315],[440,252],[436,199],[436,149],[428,126],[377,162],[319,175],[288,147],[278,103],[276,67],[276,65]]]',
      times: '[4162,5591,2783,3835,3329,5920,5750,10550,3222,6373]',
      correct: '[true,true,false,true,false,true,false,false,false,false]',
      score: '4',
      time: 51515,
      started: true,
      name: 'Robbie Lightfoot',
    },
    createdTime: '2020-12-26T11:22:07.000Z',
  },
  {
    id: 'reccHh4jcoRaJTEqC',
    fields: {
      raceNumber: 1618,
      paths:
        '[[[238,443],[258,399],[252,219],[235,30],[213,8],[211,17],[232,166]],[[305,254],[270,234],[48,193],[62,119],[111,76],[175,43],[206,44],[208,54],[235,55],[254,65],[261,77],[279,84],[298,91]],[[143,483],[33,425],[134,294],[32,212],[117,101],[137,110],[137,130]],[[168,441],[217,372],[129,310],[261,110],[220,80],[193,67],[172,62]],[[326,428],[322,454],[298,474],[188,535],[153,553],[62,427],[31,392],[89,325],[195,205],[232,168],[252,148],[320,190]],[[229,410],[187,357],[198,176],[37,154],[46,9],[185,15],[224,23],[223,72]],[[177,298],[158,314],[138,314],[134,305],[63,335],[27,266],[183,140],[169,92],[173,76]],[[317,558],[255,512],[214,486],[192,488],[137,410],[210,362],[277,297],[322,246],[263,188],[264,165],[294,136],[307,142]],[[214,393],[165,308],[196,301],[218,301],[222,288],[169,192],[129,76],[198,52],[214,73],[213,82]],[[274,455],[319,432],[421,406],[465,365],[446,329],[431,176],[433,124],[402,134],[351,176],[306,147],[287,81],[274,58]]]',
      times: '[14338,24023,19279,16654,24921,17967,18887,20000,16752,19880]',
      correct: '[true,true,false,false,false,false,false,true,true,false]',
      score: '3.5',
      time: 192701,
      started: true,
      name: 'Caz Dudley',
    },
    createdTime: '2020-12-26T11:22:07.000Z',
  },
  {
    id: 'recIm3bN75NWAu8XZ',
    fields: {
      raceNumber: 1629,
      paths:
        '[[[238,443],[256,391],[220,10],[211,15],[233,174]],[[305,254],[492,307],[425,111],[296,47],[309,93]],[[143,483],[81,383],[75,221],[136,139]],[[168,441],[209,370],[261,257],[261,114],[172,66]],[[326,428],[446,390],[389,57],[308,27],[256,152],[324,192]],[[229,410],[293,376],[388,191],[404,40],[227,35],[225,74]],[[177,298],[57,323],[33,280],[176,134],[167,81],[170,75]],[[317,558],[137,414],[314,241],[271,179],[305,146]],[[214,393],[174,312],[217,296],[140,84],[204,61],[212,81]],[[274,455],[51,295],[46,248],[271,59]]]',
      times: '[7685,9690,5956,9172,7418,7983,9651,10873,11303,6452]',
      correct: '[true,true,true,true,true,true,false,true,true,true]',
      score: '9',
      time: 86183,
      started: true,
      name: 'Anna Todd',
    },
    createdTime: '2020-12-26T11:22:07.000Z',
  },
  {
    id: 'recgKyY2CQkDzseK1',
    fields: {
      raceNumber: 1630,
      paths:
        '[[[238,443],[256,396],[249,192],[224,11],[207,17],[233,165]],[[305,254],[32,180],[153,52],[208,41],[259,66],[284,83],[304,91]],[[143,483],[79,377],[72,215],[139,133]],[[168,441],[214,373],[261,108],[179,61]],[[326,428],[407,399],[450,395],[399,61],[308,26],[250,150],[318,185],[323,190]],[[229,410],[302,383],[383,216],[404,41],[225,23],[223,75]],[[177,298],[140,312],[64,329],[27,278],[153,174],[174,139],[175,75]],[[317,558],[227,485],[194,493],[142,411],[238,329],[318,242],[260,167],[296,136],[306,147]],[[214,393],[166,318],[197,300],[218,303],[224,289],[138,81],[208,56],[221,82]],[[274,455],[412,414],[465,353],[449,347],[338,335],[255,286],[310,178],[294,124],[279,54]]]',
      times: '[8272,11793,9143,14304,17825,11503,17056,14753,10265,17593]',
      correct: '[true,true,true,true,true,true,false,true,true,false]',
      score: '8',
      time: 132507,
      started: true,
      name: 'David Todd',
    },
    createdTime: '2020-12-26T11:22:07.000Z',
  },
  {
    id: 'recwBee4eYBagG05P',
    fields: {
      raceNumber: 1674,
      paths:
        '[[[238,443],[257,404],[263,278],[258,156],[234,67],[219,5],[206,20],[231,166]],[[305,254],[231,232],[94,204],[41,178],[53,143],[174,39],[207,45],[211,68],[306,92]],[[143,483],[310,259],[143,136]],[[168,441],[214,373],[114,296],[33,243],[177,65]],[[326,428],[369,409],[405,403],[425,401],[453,387],[400,57],[352,44],[314,32],[255,147],[329,193]],[[229,410],[315,367],[375,292],[393,196],[406,40],[232,31],[221,86]],[[177,298],[153,313],[129,309],[73,330],[28,283],[69,236],[183,144],[172,72]],[[317,558],[274,515],[210,494],[177,473],[133,413],[202,366],[282,296],[317,240],[264,178],[310,148]],[[214,393],[295,383],[383,320],[298,105],[271,63],[215,84]],[[274,455],[172,408],[87,332],[42,289],[48,231],[204,120],[267,56]]]',
      times: '[7210,9299,3548,8639,13549,9235,9836,14186,10751,11039]',
      correct: '[true,true,false,false,true,true,false,true,false,true]',
      score: '6',
      time: 97292,
      started: true,
      name: 'Harry Bratcher-Howard',
    },
    createdTime: '2020-12-26T11:22:07.000Z',
  },
  {
    id: 'recP3tuDOs3XBjiam',
    fields: {
      raceNumber: 1679,
      paths:
        '[[[238,443],[270,426],[232,9],[209,13],[233,175]],[[305,254],[31,181],[199,30],[304,93]],[[143,483],[77,398],[59,201],[139,134]],[[168,441],[206,370],[195,220],[262,103],[175,65]],[[326,428],[447,393],[397,59],[303,32],[253,146],[327,190]],[[229,410],[302,381],[394,186],[407,39],[228,28],[221,78]],[[177,298],[63,333],[21,275],[180,136],[175,66]],[[317,558],[245,493],[131,419],[88,326],[182,272],[153,165],[260,168],[302,150]],[[214,393],[386,317],[273,59],[222,82]],[[274,455],[33,288],[45,239],[269,56]]]',
      times: '[6009,4671,4889,4920,6736,5944,6559,9144,5328,4263]',
      correct: '[true,true,true,false,true,true,false,false,false,true]',
      score: '6',
      time: 58463,
      started: true,
      name: 'Matthew Morris',
    },
    createdTime: '2020-12-29T15:37:53.000Z',
  },
  {
    id: 'recRMhb6aU9pBmuny',
    fields: {
      raceNumber: 1694,
      paths:
        '[[[238,443],[264,437],[237,30],[219,4],[205,16],[232,175]],[[305,254],[192,220],[51,200],[185,36],[215,54],[295,85],[302,92]],[[143,483],[35,417],[53,232],[141,140]],[[168,441],[220,370],[198,214],[261,118],[183,55],[174,63]],[[326,428],[320,446],[328,457],[447,394],[423,198],[396,57],[298,23],[254,146],[328,195]],[[229,410],[187,371],[193,189],[31,155],[50,9],[230,27],[223,72]],[[177,298],[201,328],[336,214],[250,94],[190,137],[171,70]],[[317,558],[185,482],[132,413],[319,252],[251,179],[294,141],[304,145]],[[214,393],[164,311],[201,300],[217,303],[223,288],[205,271],[132,84],[209,54],[214,76]],[[274,455],[76,337],[52,225],[202,122],[267,52]]]',
      times: '[8486,10779,7448,10757,19653,15613,11537,12715,9971,9620]',
      correct: '[true,false,true,false,false,false,true,true,true,true]',
      score: '6',
      time: 116579,
      started: true,
      name: 'Ciara Keen',
    },
    createdTime: '2020-12-26T11:22:07.000Z',
  },
  {
    id: 'recCvAfo0jw7790z1',
    fields: {
      raceNumber: 1696,
      paths:
        '[[[238,443],[266,401],[231,12],[211,13],[235,180]],[[305,254],[510,322],[416,80],[293,36],[303,98]],[[143,483],[317,250],[142,142]],[[168,441],[212,365],[190,217],[263,111],[168,60]],[[326,428],[416,405],[451,392],[402,54],[300,16],[250,141],[328,195]],[[229,410],[185,350],[187,199],[24,169],[52,7],[227,29],[230,85]],[[177,298],[208,323],[333,213],[285,158],[225,195],[167,95],[174,74]],[[317,558],[208,497],[119,416],[324,249],[263,172],[307,151]],[[214,393],[167,312],[202,302],[224,305],[224,289],[128,78],[202,48],[216,90]],[[274,455],[472,376],[457,346],[448,345],[249,301],[311,180],[277,60]]]',
      times: '[7539,7761,5039,6092,10466,11291,11088,15559,8692,11819]',
      correct: '[true,true,false,false,true,false,false,true,true,false]',
      score: '5',
      time: 95346,
      started: true,
      name: 'Naomi Thornton',
    },
    createdTime: '2020-12-26T11:22:07.000Z',
  },
  {
    id: 'recOb6PnyWyb00C2E',
    fields: {
      raceNumber: 1721,
      paths:
        '[[[238,443],[77,406],[28,217],[25,126],[91,123],[233,174]],[[305,254],[485,317],[501,285],[461,182],[373,72],[297,42],[293,55],[300,95]],[[143,483],[74,407],[68,292],[61,213],[145,137]],[[168,441],[233,332],[266,255],[253,227],[255,103],[170,60]],[[326,428],[386,398],[438,390],[424,185],[404,47],[296,20],[256,137],[320,189]],[[229,410],[303,376],[332,328],[398,161],[403,26],[225,24],[223,80]],[[177,298],[200,320],[340,217],[250,106],[194,122],[183,108],[176,71]],[[317,558],[219,490],[196,488],[128,412],[203,371],[318,255],[258,179],[307,140],[309,146]],[[214,393],[276,387],[379,318],[272,52],[221,77]],[[274,455],[180,419],[51,315],[44,230],[264,62]]]',
      times: '[6952,6102,4682,5802,8578,6524,8834,8648,11578,7762]',
      correct: '[false,true,true,true,true,true,true,true,false,true]',
      score: '8',
      time: 75462,
      started: true,
      name: 'Haruki Ohashi',
    },
    createdTime: '2020-12-26T11:22:07.000Z',
  },
  {
    id: 'reclxIWVD5YZZXpRH',
    fields: {
      raceNumber: 1732,
      paths:
        '[[[238,443],[236,447],[255,254],[219,4],[204,43],[232,173]],[[305,254],[39,187],[129,59],[206,58],[206,58],[297,90],[304,95]],[[143,483],[35,412],[61,224],[139,129]],[[168,441],[221,364],[265,259],[253,224],[260,111],[177,64]],[[326,428],[355,442],[447,393],[415,164],[400,69],[303,28],[251,150],[323,196]],[[229,410],[303,384],[397,173],[402,42],[219,23],[223,71]],[[177,298],[149,315],[130,306],[54,327],[21,272],[30,268],[177,149],[175,72]],[[317,558],[206,495],[130,420],[185,385],[318,244],[265,193],[261,190],[284,148],[305,146]],[[214,393],[143,290],[35,127],[151,64],[209,56],[216,85]],[[274,455],[103,350],[32,285],[56,220],[120,191],[208,117],[264,56]]]',
      times: '[7183,10921,7699,10779,14152,11710,10708,15861,9487,9989]',
      correct: '[true,true,true,true,true,true,false,true,false,true]',
      score: '8',
      time: 108489,
      started: true,
      name: 'Alison Campbell',
    },
    createdTime: '2020-12-26T11:22:07.000Z',
  },
  {
    id: 'reche6RinPRRV6hPz',
    fields: {
      raceNumber: 1744,
      paths:
        '[[[238,443],[255,404],[258,360],[253,261],[244,110],[224,11],[208,18],[235,169]],[[305,254],[261,241],[123,212],[39,186],[43,160],[108,81],[158,47],[202,39],[214,71],[231,78],[275,85],[303,91]],[[143,483],[243,361],[315,251],[262,221],[143,134]],[[168,441],[220,368],[34,243],[132,94],[170,66]],[[326,428],[353,423],[380,405],[376,391],[439,392],[449,379],[426,209],[402,78],[393,55],[303,27],[253,149],[326,194]],[[229,410],[180,355],[178,262],[175,186],[109,174],[33,154],[47,11],[226,23],[224,76]],[[177,298],[148,318],[131,305],[67,335],[24,287],[34,260],[121,196],[186,138],[175,71]],[[317,558],[238,502],[204,493],[129,423],[188,385],[274,300],[320,240],[259,176],[302,147]],[[214,393],[159,316],[195,299],[224,304],[205,271],[133,81],[206,52],[217,77]],[[274,455],[38,298],[51,229],[273,55]]]',
      times: '[13129,22745,14296,15352,27272,17968,17328,18537,17800,13744]',
      correct: '[true,true,false,false,true,false,false,true,true,true]',
      score: '5',
      time: 178171,
      started: true,
      name: 'Elena Gvozdeykova',
    },
    createdTime: '2020-12-26T11:22:07.000Z',
  },
  {
    id: 'rec8KYydgLyXGOfVj',
    fields: {
      raceNumber: 1760,
      paths:
        '[[[238,443],[264,389],[225,9],[201,24],[238,172]],[[305,254],[37,183],[215,23],[295,44],[307,86],[108,78],[303,93]],[[143,483],[312,255],[143,130]],[[168,441],[211,367],[29,235],[176,54],[171,64]],[[326,428],[324,459],[150,553],[28,381],[247,146],[321,190]],[[229,410],[378,300],[409,32],[220,18],[224,76]],[[177,298],[206,319],[337,217],[250,95],[183,136],[172,76]],[[317,558],[230,478],[128,411],[212,364],[322,243],[258,175],[297,137],[308,145]],[[214,393],[170,310],[220,301],[131,79],[206,49],[215,76]],[[274,455],[472,370],[446,340],[247,297],[312,171],[280,55]]]',
      times: '[10580,18909,8091,14332,13284,10311,8329,12737,11954,14794]',
      correct: '[true,false,false,false,false,true,true,false,true,false]',
      score: '4',
      time: 123321,
      started: true,
      name: 'Jon Wheatcroft',
    },
    createdTime: '2020-12-26T11:22:07.000Z',
  },
  {
    id: 'recd0tffTYe5QcvDX',
    fields: {
      raceNumber: 1766,
      paths:
        '[[[238,443],[86,405],[48,438],[27,123],[56,126],[238,177]],[[305,254],[496,320],[472,209],[411,108],[370,78],[296,46],[294,54],[306,63],[260,50],[249,68],[256,75],[306,94]],[[143,483],[311,253],[147,132]],[[168,441],[222,375],[39,232],[172,61]],[[326,428],[351,441],[449,386],[419,177],[394,50],[304,21],[251,144],[330,195]],[[229,410],[294,389],[393,189],[399,36],[293,34],[222,26],[222,78]],[[177,298],[206,319],[331,212],[245,105],[178,126],[172,77]],[[317,558],[231,490],[205,493],[138,414],[270,300],[319,246],[255,182],[297,142],[308,146]],[[214,393],[172,311],[231,299],[225,282],[136,74],[210,54],[214,83]],[[274,455],[425,408],[461,345],[263,295],[253,276],[309,164],[278,54]]]',
      times: '[14970,15618,8356,13700,16732,18446,14300,14962,15260,14110]',
      correct: '[false,true,false,false,true,true,true,true,true,false]',
      score: '6',
      time: 146454,
      started: true,
      name: 'Rosie Shaw',
    },
    createdTime: '2020-12-26T11:22:07.000Z',
  },
  {
    id: 'recv6Xc4sX2wFFb87',
    fields: {
      raceNumber: 1774,
      paths:
        '[[[238,443],[242,444],[37,381],[26,129],[238,175]],[[305,254],[314,257],[503,324],[439,132],[307,39],[296,55],[308,90]],[[143,483],[147,482],[32,412],[74,192],[139,135]],[[168,441],[176,440],[233,345],[271,255],[243,191],[254,126],[266,110],[187,60],[171,66]],[[326,428],[331,434],[374,443],[455,398],[401,58],[298,26],[248,143],[323,196]],[[229,410],[233,410],[309,391],[395,199],[407,31],[228,17],[222,77]],[[177,298],[173,300],[149,320],[127,306],[67,338],[25,279],[186,145],[174,68]],[[317,558],[321,555],[231,489],[214,497],[132,424],[323,252],[256,183],[309,148]],[[214,393],[224,399],[167,317],[218,305],[223,295],[177,193],[136,84],[211,48],[223,82],[216,80]],[[274,455],[281,447],[470,370],[447,339],[260,300],[311,168],[276,63]]]',
      times: '[8665,12375,9441,18024,13679,10943,11624,11984,30801,19825]',
      correct: '[false,true,true,true,true,true,false,true,true,false]',
      score: '6.5',
      time: 147361,
      started: true,
      name: 'John Marshall',
    },
    createdTime: '2020-12-26T11:22:07.000Z',
  },
  {
    id: 'rec18vYhYNkcxdMly',
    fields: {
      raceNumber: 1776,
      paths:
        '[[[238,443],[260,392],[247,113],[221,16],[211,18],[232,169]],[[305,254],[47,196],[33,174],[121,67],[201,46],[220,57],[245,62],[311,96]],[[143,483],[76,389],[67,219],[137,141]],[[168,441],[216,370],[257,250],[253,224],[260,114],[215,78],[173,61]],[[326,428],[354,434],[446,383],[396,54],[303,30],[252,142],[320,188]],[[229,410],[304,371],[350,314],[401,43],[227,26],[225,72]],[[177,298],[203,321],[334,220],[244,111],[187,136],[169,74]],[[317,558],[226,492],[200,490],[133,414],[194,378],[323,244],[258,178],[302,145]],[[214,393],[168,312],[202,301],[224,297],[186,223],[137,82],[202,59],[213,80]],[[274,455],[464,380],[459,341],[300,320],[254,289],[311,176],[271,57]]]',
      times: '[15047,16287,8095,15030,15221,17036,12479,29357,27188,26180]',
      correct: '[true,true,true,true,true,true,true,true,true,false]',
      score: '8',
      time: 181920,
      started: true,
      name: 'Andy Paterson',
    },
    createdTime: '2020-12-26T11:22:07.000Z',
  },
  {
    id: 'rec0obKVxARR03sSp',
    fields: {
      raceNumber: 1784,
      paths:
        '[[[238,443],[267,415],[229,10],[193,24],[233,178]],[[305,254],[46,196],[223,24],[286,59],[254,76],[305,93]],[[143,483],[29,410],[70,216],[141,135]],[[168,441],[219,357],[199,205],[262,112],[169,65]],[[326,428],[319,465],[156,559],[27,388],[246,154],[322,192]],[[229,410],[40,265],[24,254],[44,9],[228,24],[223,71]],[[177,298],[151,320],[136,304],[53,334],[19,282],[182,139],[172,71]],[[317,558],[226,489],[204,495],[129,419],[31,194],[168,172],[306,149]],[[214,393],[275,395],[389,310],[262,51],[213,80]],[[274,455],[209,425],[32,304],[45,237],[192,128],[272,57]]]',
      times: '[7018,8618,5945,8233,12906,14480,13114,18610,8592,14545]',
      correct: '[true,false,true,false,false,false,false,false,false,true]',
      score: '3',
      time: 112061,
      started: true,
      name: 'Aurelie Andry',
    },
    createdTime: '2020-12-26T11:22:07.000Z',
  },
  {
    id: 'recP649qZbEQ6SUWy',
    fields: {
      raceNumber: 1803,
      paths:
        '[[[238,443],[260,403],[225,11],[209,21],[234,175]],[[305,254],[35,191],[99,86],[195,39],[221,52],[307,97]],[[143,483],[36,419],[60,231],[137,137]],[[168,441],[211,368],[190,216],[259,115],[183,58],[176,59]],[[326,428],[319,457],[151,554],[32,392],[251,151],[323,193]],[[229,410],[193,365],[183,202],[36,163],[49,14],[225,23],[221,73]],[[177,298],[63,330],[25,277],[176,143],[171,77]],[[317,558],[233,494],[187,483],[127,415],[312,255],[263,176],[305,148]],[[214,393],[380,320],[274,74],[213,81]],[[274,455],[43,299],[48,240],[269,54]]]',
      times: '[7498,12503,9391,12973,19796,15664,14003,20101,12426,11257]',
      correct: '[true,true,true,false,false,false,false,true,false,true]',
      score: '4.5',
      time: 135612,
      started: true,
      name: 'Peter Reitsema',
    },
    createdTime: '2020-12-26T11:22:07.000Z',
  },
  {
    id: 'reczjLKxZmnbHwPtE',
    fields: {
      raceNumber: 1814,
      paths:
        '[[[238,443],[264,264],[238,45],[215,11],[207,48],[231,169]],[[305,254],[28,198],[124,69],[208,47],[304,92]],[[143,483],[40,417],[59,240],[138,134]],[[168,441],[215,363],[187,214],[263,106],[177,64]],[[326,428],[358,439],[442,397],[398,58],[301,34],[250,150],[326,191]],[[229,410],[340,319],[398,213],[406,33],[227,21],[224,77]],[[177,298],[59,334],[15,274],[182,144],[172,69]],[[317,558],[128,424],[278,291],[324,238],[252,176],[306,142]],[[214,393],[384,327],[276,34],[217,77]],[[274,455],[35,278],[269,61]]]',
      times: '[7936,7272,7927,8065,13432,10465,8592,13568,10784,10816]',
      correct: '[true,true,true,false,true,true,false,true,false,true]',
      score: '7',
      time: 98857,
      started: true,
      name: 'Robyn Stanyon',
    },
    createdTime: '2020-12-26T11:22:07.000Z',
  },
  {
    id: 'recE7CL2rtFEg0YF5',
    fields: {
      raceNumber: 1826,
      paths:
        '[[[238,443],[265,429],[230,15],[210,18],[230,171]],[[305,254],[33,196],[53,129],[85,102],[157,53],[201,36],[213,78],[236,73],[275,81],[293,85],[206,57],[231,54],[259,54],[291,57],[307,60],[308,75],[308,88]],[[143,483],[307,257],[152,129],[144,131]],[[168,441],[216,372],[31,238],[170,62]],[[326,428],[320,440],[321,470],[179,544],[165,555],[27,391],[141,265],[214,184],[246,153],[329,196]],[[229,410],[310,385],[321,326],[395,205],[407,42],[286,18],[285,19],[231,23],[227,74]],[[177,298],[144,321],[127,307],[63,328],[27,282],[36,254],[192,137],[161,95],[176,72]],[[317,558],[231,487],[217,493],[130,419],[231,489],[497,229],[430,164],[357,222],[330,243],[274,190],[259,171],[293,135],[305,144]],[[214,393],[184,304],[216,299],[208,258],[200,254],[152,159],[134,94],[144,67],[206,52],[214,75]],[[274,455],[403,414],[438,386],[437,345],[273,455],[209,430],[151,394],[103,366],[67,330],[44,300],[35,260],[67,227],[103,197],[146,164],[226,100],[267,60]]]',
      times: '[13064,27106,20236,13759,18759,20287,26590,32008,18742,31511]',
      correct: '[true,true,false,false,false,true,false,false,true,false]',
      score: '3',
      time: 222062,
      started: true,
      name: 'Penny Rodgers',
    },
    createdTime: '2020-12-26T11:22:07.000Z',
  },
  {
    id: 'recHTFGUrgOJoEhVg',
    fields: {
      raceNumber: 1829,
      paths:
        '[[[238,443],[259,352],[257,151],[217,8],[205,20],[233,174]],[[305,254],[34,187],[129,62],[199,37],[298,41],[306,65],[212,51],[248,64],[270,79],[284,79],[301,91]],[[143,483],[313,256],[147,129],[144,131]],[[168,441],[217,372],[193,219],[262,110],[193,61],[169,63]],[[326,428],[377,404],[408,399],[447,392],[417,159],[397,56],[301,26],[247,137],[329,191]],[[229,410],[307,366],[377,283],[401,154],[404,29],[226,16],[223,70]],[[177,298],[147,319],[128,298],[63,335],[18,268],[188,139],[172,66]],[[317,558],[563,297],[422,161],[323,247],[257,172],[298,138],[305,147]],[[214,393],[254,398],[391,319],[271,54],[216,77]],[[274,455],[468,367],[458,335],[342,335],[245,295],[309,166],[275,55]]]',
      times: '[18522,30626,15564,27978,48029,21962,31631,51270,29268,19484]',
      correct: '[true,true,false,false,true,true,false,false,false,false]',
      score: '2.5',
      time: 294334,
      started: true,
      name: 'Steve Robertson',
    },
    createdTime: '2020-12-26T11:22:07.000Z',
  },
  {
    id: 'recKxtzvUNvUq9iL1',
    fields: {
      raceNumber: 1831,
      paths:
        '[[[238,443],[262,430],[256,276],[234,42],[222,15],[209,19],[236,174]],[[305,254],[152,235],[38,171],[145,54],[195,39],[212,67],[246,79],[272,85],[292,91],[304,94]],[[143,483],[118,459],[77,386],[67,225],[142,135]],[[168,441],[213,370],[195,221],[264,110],[192,64],[172,63]],[[326,428],[384,400],[417,400],[446,388],[395,56],[308,29],[256,147],[327,191]],[[229,410],[302,380],[387,191],[397,41],[223,33],[222,77]],[[177,298],[201,321],[332,218],[248,112],[188,130],[172,74]],[[317,558],[234,495],[141,441],[135,417],[311,257],[311,240],[260,183],[295,148],[306,147]],[[214,393],[166,316],[193,302],[219,304],[201,284],[127,83],[196,55],[215,80]],[[274,455],[384,424],[464,372],[461,345],[268,311],[251,295],[306,179],[275,56]]]',
      times: '[11044,17854,8541,9854,19358,17517,12772,13475,17539,13460]',
      correct: '[true,true,true,false,true,true,true,true,true,false]',
      score: '8',
      time: 141414,
      started: true,
      name: 'Richard Gardner',
    },
    createdTime: '2020-12-26T11:22:07.000Z',
  },
  {
    id: 'recE5OuMN4zOZMf0h',
    fields: {
      raceNumber: 1848,
      paths:
        '[[[238,443],[255,386],[230,19],[211,16],[207,128],[230,175]],[[305,254],[32,173],[195,37],[221,74],[308,97]],[[143,483],[308,252],[145,137]],[[168,441],[224,366],[193,221],[264,111],[176,64]],[[326,428],[353,439],[449,391],[401,55],[303,26],[253,151],[326,193]],[[229,410],[305,373],[406,178],[394,29],[226,22],[225,83]],[[177,298],[149,318],[126,307],[60,333],[27,271],[186,143],[172,73]],[[317,558],[219,487],[201,497],[134,414],[322,247],[251,175],[306,143]],[[214,393],[38,111],[211,54],[215,82]],[[274,455],[462,355],[250,297],[308,161],[273,56]]]',
      times: '[11666,12788,14529,15433,18302,18702,18804,17817,16794,13165]',
      correct: '[true,true,false,false,true,true,false,true,false,false]',
      score: '5',
      time: 158000,
      started: true,
      name: 'John Brammer',
    },
    createdTime: '2020-12-26T11:22:07.000Z',
  },
  {
    id: 'recGKK2VdJBBXkEs2',
    fields: {
      raceNumber: 1849,
      paths:
        '[[[238,443],[236,446],[239,412],[263,404],[257,256],[227,14],[203,20],[228,171]],[[305,254],[287,250],[46,180],[133,60],[200,38],[207,50],[245,49],[313,68],[301,88]],[[143,483],[146,483],[311,249],[150,126],[138,134]],[[168,441],[170,439],[223,374],[194,222],[262,107],[209,65],[167,63]],[[326,428],[329,435],[354,423],[376,407],[387,392],[414,414],[444,388],[403,57],[302,25],[252,145],[323,195]],[[229,410],[227,407],[191,390],[173,183],[28,166],[69,4],[219,12],[228,73]],[[177,298],[177,299],[203,325],[339,212],[243,102],[192,143],[167,104],[170,74]],[[317,558],[307,561],[231,492],[189,481],[153,407],[196,376],[319,244],[256,170],[287,141],[310,151]],[[214,393],[390,305],[277,48],[215,76]],[[274,455],[272,445],[146,390],[52,329],[40,247],[90,205],[207,112],[267,54]]]',
      times: '[12434,12640,8314,12388,19735,15120,12816,14392,12198,15004]',
      correct: '[true,true,false,false,true,false,true,true,false,true]',
      score: '6',
      time: 135041,
      started: true,
      name: 'Caroline Brammer',
    },
    createdTime: '2020-12-26T11:22:07.000Z',
  },
  {
    id: 'recruulIqQkLdAYGR',
    fields: {
      raceNumber: 1851,
      paths:
        '[[[238,443],[236,441],[49,389],[30,127],[237,175]],[[305,254],[299,251],[28,180],[133,58],[202,38],[213,71],[304,93]],[[143,483],[142,478],[32,276],[139,134]],[[168,441],[179,429],[218,371],[198,218],[263,108],[186,59],[174,59]],[[326,428],[328,431],[361,442],[450,388],[400,57],[308,29],[253,148],[325,193]],[[229,410],[232,412],[298,381],[392,181],[400,42],[226,28],[225,78]],[[177,298],[184,300],[204,319],[330,218],[247,111],[183,128],[172,72]],[[317,558],[305,551],[231,495],[193,490],[134,417],[188,388],[323,249],[264,180],[294,145],[304,146]],[[214,393],[214,398],[169,313],[203,302],[227,293],[207,278],[138,82],[206,53],[220,80]],[[274,455],[276,444],[150,390],[44,306],[44,244],[101,204],[273,52]]]',
      times: '[9968,15223,11232,14095,17672,16648,18000,17664,20679,13416]',
      correct: '[false,true,true,false,true,true,true,true,true,true]',
      score: '7.5',
      time: 154597,
      started: true,
      name: 'Joe Parkinson',
    },
    createdTime: '2020-12-26T11:22:07.000Z',
  },
  {
    id: 'recq2Cl2v20nqNHC2',
    fields: {
      raceNumber: 1858,
      paths:
        '[[[238,443],[262,394],[228,12],[201,22],[233,177]],[[305,254],[34,194],[61,105],[196,34],[213,55],[215,73],[283,86],[303,95]],[[143,483],[320,256],[147,136]],[[168,441],[217,374],[133,310],[266,108],[186,59],[169,62]],[[326,428],[362,443],[437,396],[420,286],[327,199]],[[229,410],[307,381],[361,308],[402,205],[416,38],[228,21],[222,73]],[[177,298],[219,265],[182,231],[167,239],[139,201],[179,149],[178,120],[174,73]],[[317,558],[232,483],[433,289],[373,215],[326,244],[260,174],[311,149]],[[214,393],[95,219],[39,119],[170,65],[212,51],[216,82]],[[274,455],[276,391],[287,338],[257,304],[268,269],[311,171],[286,90],[273,56]]]',
      times: '[7912,9723,5841,9460,9282,12063,11288,23720,13274,18526]',
      correct: '[true,true,false,false,false,true,false,false,false,false]',
      score: '3',
      time: 121089,
      started: true,
      name: 'David Roy',
    },
    createdTime: '2020-12-26T11:22:07.000Z',
  },
  {
    id: 'rec11qiDxDwQIZ0dj',
    fields: {
      raceNumber: 1877,
      paths:
        '[[[238,443],[35,221],[26,126],[233,171]],[[305,254],[494,314],[441,150],[296,40],[309,86],[307,95]],[[143,483],[54,422],[119,318],[68,211],[138,130]],[[168,441],[212,361],[194,219],[259,106],[175,56],[170,64]],[[326,428],[352,437],[440,392],[423,294],[323,188]],[[229,410],[192,350],[176,197],[36,152],[49,12],[223,26],[221,76]],[[177,298],[209,265],[165,230],[138,184],[194,132],[169,69]],[[317,558],[559,299],[416,164],[464,112],[391,39],[309,142]],[[214,393],[167,314],[202,300],[220,308],[219,285],[190,237],[135,76],[203,52],[216,79]],[[274,455],[118,359],[35,283],[55,225],[198,121],[278,48],[278,57]]]',
      times: '[17697,16626,15344,14521,18288,16912,27024,26505,17473,15725]',
      correct: '[false,true,true,false,false,false,false,false,true,true]',
      score: '4',
      time: 186115,
      started: true,
      name: "Marie O'Donovan",
    },
    createdTime: '2020-12-26T11:22:07.000Z',
  },
  {
    id: 'recmgtsyurW92OhQd',
    fields: {
      raceNumber: 1881,
      paths:
        '[[[238,443],[58,399],[24,125],[235,171]],[[305,254],[42,185],[187,33],[219,73],[300,90]],[[143,483],[311,257],[137,134]],[[168,441],[213,382],[270,256],[247,126],[259,98],[170,65]],[[326,428],[446,392],[395,53],[303,27],[260,157],[320,192]],[[229,410],[307,378],[396,213],[402,36],[222,21],[222,76]],[[177,298],[142,318],[54,326],[24,270],[180,136],[167,72]],[[317,558],[234,496],[134,424],[316,248],[259,173],[302,148]],[[214,393],[374,314],[273,56],[212,79]],[[274,455],[461,372],[439,129],[376,161],[319,165],[271,56]]]',
      times: '[6638,7625,3528,7177,9537,6929,9168,10482,8449,7490]',
      correct: '[false,false,false,true,true,true,false,true,false,false]',
      score: '4',
      time: 77023,
      started: true,
      name: 'Philipp Haider',
    },
    createdTime: '2020-12-27T21:53:47.000Z',
  },
  {
    id: 'recdmuVBWDQo3W5JY',
    fields: {
      raceNumber: 1912,
      paths:
        '[[[238,443],[76,391],[21,158],[30,139],[39,135],[237,177]],[[305,254],[44,207],[26,181],[139,62],[203,49],[301,103]],[[143,483],[81,387],[65,218],[139,143]],[[168,441],[211,371],[258,119],[201,63],[177,70]],[[326,428],[431,396],[449,385],[396,59],[310,36],[255,153],[319,198]],[[229,410],[294,387],[386,216],[401,48],[301,32],[231,32],[232,79]],[[177,298],[206,323],[332,223],[264,110],[193,136],[166,78],[177,75]],[[317,558],[558,299],[424,171],[335,246],[263,176],[296,145],[312,152]],[[214,393],[272,392],[374,328],[272,59],[213,82]],[[274,455],[169,407],[36,304],[49,233],[193,142],[268,67],[273,61]]]',
      times: '[9190,9159,7379,7258,11899,8438,8811,13498,11228,12330]',
      correct: '[false,true,true,true,true,true,true,false,false,true]',
      score: '7',
      time: 99190,
      started: true,
      name: 'Tony Udris',
    },
    createdTime: '2020-12-26T11:22:07.000Z',
  },
  {
    id: 'rectcdyE1276Tp02Z',
    fields: {
      raceNumber: 1914,
      paths:
        '[[[238,443],[249,445],[270,408],[259,224],[232,9],[204,24],[238,171]],[[305,254],[312,255],[47,216],[33,162],[99,74],[184,35],[208,52],[213,75],[247,76],[282,85],[304,93]],[[143,483],[144,477],[35,419],[51,310],[60,228],[134,133]],[[168,441],[221,362],[256,246],[249,205],[252,126],[267,106],[179,55],[172,61]],[[326,428],[327,464],[137,550],[28,376],[152,248],[250,150],[320,192]],[[229,410],[266,408],[312,360],[394,195],[404,29],[224,19],[221,76]],[[177,298],[207,323],[343,219],[259,97],[189,127],[167,96],[169,66]],[[317,558],[227,491],[122,411],[185,382],[239,336],[322,250],[257,191],[298,142],[315,151]],[[214,393],[167,355],[160,317],[50,119],[78,97],[212,59],[218,77]],[[274,455],[310,436],[433,400],[470,344],[445,340],[444,261],[443,123],[420,113],[374,164],[298,151],[281,103],[276,61]]]',
      times: '[9662,16254,14025,13150,13791,13294,14087,21667,16022,17661]',
      correct: '[true,true,true,true,false,true,true,true,false,false]',
      score: '6.5',
      time: 149613,
      started: true,
      name: 'Dave Smith',
    },
    createdTime: '2020-12-26T11:22:07.000Z',
  },
  {
    id: 'rechN6TEqfnjEWM4i',
    fields: {
      raceNumber: 1999,
      paths:
        '[[[238,443],[275,332],[230,141],[239,152],[237,189],[235,173]],[[305,254],[271,154],[334,107],[310,95]],[[143,483],[68,278],[168,126],[142,136]],[[168,441],[256,94],[182,66],[173,62]],[[326,428],[394,288],[327,200]],[[229,410],[113,154],[231,86],[229,76]],[[177,298],[187,62],[166,62]],[[317,558],[223,219],[313,148]],[[214,393],[295,128],[195,81],[215,83]],[[274,455],[271,59]]]',
      times: '[18320,7216,8031,6168,6375,5897,6280,5368,5681,5363]',
      correct: '[false,false,false,false,false,false,false,false,false,false]',
      score: '0',
      time: 74699,
      started: true,
      name: 'Peter Errington',
    },
    createdTime: '2020-12-26T11:22:07.000Z',
  },
  {
    id: 'recSNMOO0XkB6F4EO',
    fields: {
      raceNumber: 2028,
      paths:
        '[[[238,443],[272,441],[215,13],[192,34],[240,175]],[[305,254],[22,185],[173,31],[212,63],[296,88],[306,91]],[[143,483],[39,420],[29,213],[131,101],[148,118],[137,143]],[[168,441],[210,373],[255,124],[272,101],[182,38],[171,76]],[[326,428],[400,404],[431,404],[449,384],[397,59],[299,20],[257,147],[327,195]],[[229,410],[322,366],[392,199],[381,30],[227,20],[224,83]],[[177,298],[209,315],[332,220],[252,94],[186,149],[168,69]],[[317,558],[224,484],[211,494],[134,417],[325,242],[256,186],[295,141],[308,154]],[[214,393],[159,317],[187,304],[208,304],[226,283],[138,91],[198,52],[219,83]],[[274,455],[466,363],[453,343],[252,304],[313,160],[274,68],[274,66]]]',
      times: '[8728,12521,7825,9300,17123,15608,13587,20433,16064,12967]',
      correct: '[true,true,false,true,true,true,true,true,true,false]',
      score: '7.5',
      time: 134156,
      started: true,
      name: 'Ben Bardsley',
    },
    createdTime: '2020-12-26T11:22:07.000Z',
  },
  {
    id: 'recKfaboxyYrA9nCh',
    fields: {
      raceNumber: 2054,
      paths:
        '[[[238,443],[266,421],[256,186],[218,4],[203,20],[232,173]],[[305,254],[491,324],[495,285],[444,142],[339,43],[300,40],[295,62],[267,62],[303,79],[254,78],[306,95]],[[143,483],[269,324],[320,253],[146,134]],[[168,441],[198,407],[225,332],[260,120],[263,100],[172,57],[172,67]],[[326,428],[390,398],[449,394],[441,303],[398,57],[305,28],[245,145],[326,195]],[[229,410],[312,373],[392,181],[404,35],[220,17],[225,74]],[[177,298],[149,319],[130,300],[58,336],[21,277],[181,140],[173,74]],[[317,558],[223,488],[157,456],[128,415],[228,342],[320,250],[256,176],[304,147]],[[214,393],[329,365],[384,318],[261,44],[215,78]],[[274,455],[311,435],[372,427],[471,375],[457,340],[329,332],[253,296],[303,190],[299,149],[278,55]]]',
      times: '[8190,14635,4614,13384,13782,13483,12603,13920,11109,20646]',
      correct: '[true,true,false,true,true,true,false,true,false,false]',
      score: '6',
      time: 126366,
      started: true,
      name: 'Max Straube-Roth',
    },
    createdTime: '2020-12-26T11:22:07.000Z',
  },
  {
    id: 'recfjN03VkVx1X5MA',
    fields: {
      raceNumber: 2095,
      paths:
        '[[[238,443],[216,11],[204,19],[232,173]],[[305,254],[40,177],[199,38],[215,72],[302,93]],[[143,483],[37,415],[62,228],[142,126],[140,131]],[[168,441],[214,369],[260,105],[171,61]],[[326,428],[410,402],[451,387],[399,56],[304,31],[255,146],[322,195]],[[229,410],[316,380],[396,190],[403,29],[226,24],[224,73]],[[177,298],[212,332],[331,209],[251,110],[190,131],[170,71]],[[317,558],[128,412],[328,247],[250,177],[309,146]],[[214,393],[384,318],[269,58],[209,80]],[[274,455],[37,292],[51,230],[266,55]]]',
      times: '[9593,8409,10132,6585,10575,9112,13665,13283,9030,13861]',
      correct: '[true,true,true,true,true,true,true,true,false,true]',
      score: '9',
      time: 104245,
      started: true,
      name: 'Matthias Kalle Dalheimer',
    },
    createdTime: '2020-12-26T11:22:07.000Z',
  },
  {
    id: 'recp5Rti0BfaNZwXh',
    fields: {
      raceNumber: 2274,
      paths:
        '[[[238,443],[234,439],[252,377],[220,15],[209,15],[231,171]],[[305,254],[306,257],[44,197],[50,158],[204,42],[219,51],[280,58],[306,91]],[[143,483],[138,473],[82,392],[73,215],[138,140]],[[168,441],[175,431],[210,366],[195,220],[263,115],[176,62]],[[326,428],[326,428],[358,436],[448,392],[398,56],[303,31],[254,145],[328,188]],[[229,410],[229,408],[301,367],[367,283],[391,176],[407,37],[226,24],[224,73]],[[177,298],[180,295],[154,315],[137,309],[73,330],[31,274],[176,143],[174,72]],[[317,558],[311,552],[234,488],[202,490],[138,420],[221,348],[320,247],[265,179],[308,152]],[[214,393],[210,399],[49,129],[202,55],[215,79]],[[274,455],[273,452],[58,319],[48,238],[272,53]]]',
      times: '[6313,9641,5585,7328,13704,13097,10057,12160,11696,10512]',
      correct: '[true,true,true,false,true,true,false,true,false,true]',
      score: '7',
      time: 100093,
      started: true,
      name: 'Michael Billinghurst',
    },
    createdTime: '2020-12-24T14:01:08.000Z',
  },
  {
    id: 'reccsUnEFJIeVUXkJ',
    fields: {
      raceNumber: 2454,
      paths:
        '[[[238,443],[261,398],[219,12],[206,14],[236,176]],[[305,254],[26,185],[201,36],[219,71],[306,92]],[[143,483],[311,252],[143,132]],[[168,441],[216,372],[263,113],[161,64],[169,69]],[[326,428],[142,549],[38,386],[254,151],[325,196]],[[229,410],[286,385],[393,184],[403,46],[223,24],[220,76]],[[177,298],[146,319],[134,307],[59,327],[32,271],[189,150],[170,70]],[[317,558],[134,417],[323,240],[273,176],[315,146]],[[214,393],[173,312],[215,300],[140,84],[219,76]],[[274,455],[51,294],[51,244],[276,55]]]',
      times: '[5913,6592,2568,6848,8920,7849,9625,6976,8920,7895]',
      correct: '[true,true,false,true,false,true,false,true,true,true]',
      score: '7',
      time: 72106,
      started: true,
      name: 'Oliver Bardsley',
    },
    createdTime: '2020-12-26T11:22:07.000Z',
  },
  {
    id: 'reci57rwv4d3zJ8Uk',
    fields: {
      raceNumber: 2888,
      paths:
        '[[[238,443],[253,391],[223,16],[206,18],[231,172]],[[305,254],[36,176],[163,47],[208,41],[214,72],[303,92]],[[143,483],[311,254],[145,135]],[[168,441],[216,366],[260,257],[251,231],[256,122],[262,111],[193,60],[176,65]],[[326,428],[343,425],[349,438],[447,388],[398,55],[309,28],[254,146],[323,192]],[[229,410],[311,368],[383,250],[400,43],[227,27],[223,75]],[[177,298],[201,320],[330,222],[248,108],[185,131],[175,76]],[[317,558],[233,491],[188,486],[130,416],[282,290],[323,247],[256,181],[301,143]],[[214,393],[300,381],[383,320],[271,53],[211,78]],[[274,455],[470,367],[450,335],[431,120],[317,177],[279,60]]]',
      times: '[11080,12426,5656,15264,15680,10088,10879,13760,9159,10256]',
      correct: '[true,true,false,true,true,true,true,true,false,false]',
      score: '7',
      time: 114248,
      started: true,
      name: 'Jon Darley',
    },
    createdTime: '2020-12-26T11:22:07.000Z',
  },

  {
    id: 'recwlxmeWLpdgf0Nv',
    fields: {
      raceNumber: 3003,
      paths:
        '[[[238,443],[256,296],[225,6],[204,22],[237,172]],[[305,254],[12,206],[188,33],[208,54],[238,76],[304,92]],[[143,483],[19,395],[54,232],[134,137]],[[168,441],[220,359],[185,228],[265,105],[173,61]],[[326,428],[452,388],[398,57],[302,29],[250,147],[324,193]],[[229,410],[374,298],[410,23],[227,26],[229,76]],[[177,298],[63,334],[20,281],[191,135],[172,70]],[[317,558],[228,491],[126,420],[327,244],[249,178],[314,147]],[[214,393],[160,321],[228,290],[130,76],[213,47],[216,77]],[[274,455],[31,268],[120,189],[266,52]]]',
      times: '[13256,11992,8416,10985,25513,15897,18441,15288,12112,13064]',
      correct: '[true,true,true,false,true,true,false,true,true,true]',
      score: '7.5',
      time: 144964,
      started: true,
      name: 'Clare Lonergan',
    },
    createdTime: '2020-12-25T13:46:28.000Z',
  },
  {
    id: 'rec4M4ckstxP349Au',
    fields: {
      raceNumber: 3523,
      paths:
        '[[[238,443],[257,281],[221,9],[209,22],[233,174]],[[305,254],[34,187],[88,100],[195,38],[219,73],[306,97]],[[143,483],[308,257],[147,139]],[[168,441],[220,370],[191,219],[262,106],[173,63]],[[326,428],[350,436],[447,387],[397,55],[302,31],[248,148],[321,192]],[[229,410],[318,364],[335,324],[387,184],[396,46],[224,26],[220,77]],[[177,298],[159,312],[136,311],[69,336],[21,273],[186,132],[174,71]],[[317,558],[229,493],[144,441],[130,420],[206,364],[325,241],[256,181],[297,143],[303,146]],[[214,393],[276,385],[327,351],[301,288],[367,255],[265,53],[213,81]],[[274,455],[162,391],[46,306],[51,236],[273,48]]]',
      times: '[9084,12163,7668,9417,14909,11735,13982,15629,15346,8460]',
      correct: '[true,true,false,false,true,true,false,true,false,true]',
      score: '6',
      time: 118393,
      started: true,
      name: 'Melanie Slade',
    },
    createdTime: '2020-12-26T11:22:07.000Z',
  },
  {
    id: 'recIjOQqlc8G7z4Dy',
    fields: {
      raceNumber: 3524,
      paths:
        '[[[238,443],[67,407],[23,158],[23,133],[87,130],[234,175]],[[305,254],[32,199],[154,37],[212,49],[212,68],[215,75],[303,92]],[[143,483],[334,253],[140,135]],[[168,441],[253,311],[259,238],[239,135],[261,112],[217,60],[169,69]],[[326,428],[316,464],[153,560],[22,385],[247,151],[323,192]],[[229,410],[369,369],[415,33],[219,14],[219,77]],[[177,298],[151,321],[134,302],[61,335],[19,270],[186,137],[175,70]],[[317,558],[561,310],[424,162],[322,241],[258,176],[303,142]],[[214,393],[42,120],[187,51],[215,79]],[[274,455],[466,371],[452,333],[436,107],[336,176],[271,54]]]',
      times: '[7661,8042,3277,9273,8358,6091,7773,9743,3907,7365]',
      correct: '[false,true,false,true,false,true,false,false,false,false]',
      score: '3',
      time: 71490,
      started: true,
      name: 'Charlotte Slade',
    },
    createdTime: '2020-12-26T11:22:07.000Z',
  },
  {
    id: 'recBwX7LP3x1Nohij',
    fields: {
      raceNumber: 3569,
      paths:
        '[[[238,443],[242,436],[253,408],[254,346],[255,226],[242,72],[218,14],[205,16],[222,71],[239,177]],[[305,254],[304,247],[493,316],[497,277],[439,143],[328,44],[303,48],[304,61],[314,88],[310,99]],[[143,483],[145,481],[97,469],[44,430],[51,405],[135,298],[58,229],[141,141]],[[168,441],[168,444],[217,361],[35,243],[74,182],[137,94],[169,67]],[[326,428],[326,434],[352,439],[420,415],[450,377],[397,63],[306,22],[271,106],[257,149],[331,195]],[[229,410],[229,411],[305,373],[341,306],[390,214],[400,44],[300,24],[220,26],[222,80]],[[177,298],[179,299],[158,318],[141,314],[133,300],[80,329],[35,301],[25,270],[82,230],[167,162],[187,132],[178,100],[175,78]],[[317,558],[308,549],[234,484],[198,490],[161,460],[129,413],[199,376],[261,316],[324,246],[280,207],[261,181],[288,149],[308,143]],[[214,393],[211,393],[170,318],[182,303],[199,302],[213,306],[223,290],[181,212],[159,122],[142,82],[203,54],[221,87]],[[274,455],[274,447],[177,414],[88,335],[41,284],[53,232],[114,197],[185,135],[217,107],[264,58]]]',
      times: '[9323,12955,12569,11874,17167,16352,16561,15719,12994,10973]',
      correct: '[true,true,true,false,true,true,false,true,true,true]',
      score: '8',
      time: 136487,
      started: true,
      name: 'Emese Sváb',
    },
    createdTime: '2020-12-26T11:22:07.000Z',
  },
  {
    id: 'recPciXotObFAcRwg',
    fields: {
      raceNumber: 3786,
      paths:
        '[[[238,443],[235,445],[275,359],[257,235],[255,104],[235,27],[219,4],[199,32],[231,173]],[[305,254],[17,200],[212,6],[302,32],[303,100]],[[143,483],[324,270],[141,132]],[[168,441],[224,370],[200,195],[262,102],[169,64]],[[326,428],[323,463],[154,562],[28,391],[251,148],[321,191]],[[229,410],[193,209],[37,169],[46,8],[231,19],[220,81]],[[177,298],[205,323],[345,216],[257,100],[182,137],[172,68]],[[317,558],[221,485],[125,418],[320,247],[256,181],[307,147]],[[214,393],[39,111],[185,56],[201,54],[211,84]],[[274,455],[81,335],[44,232],[272,53]]]',
      times: '[7924,7526,3846,6936,7664,10438,7347,10586,8062,5839]',
      correct: '[true,true,false,false,false,false,true,true,false,true]',
      score: '5',
      time: 76168,
      started: true,
      name: 'Emma Crawford',
    },
    createdTime: '2020-12-26T11:22:07.000Z',
  },
  {
    id: 'recIEKWzs9hvxYyWH',
    fields: {
      raceNumber: 3829,
      paths:
        '[[[238,443],[267,374],[258,176],[220,4],[205,22],[234,176]],[[305,254],[239,229],[37,191],[72,111],[160,42],[239,35],[304,35],[293,57],[307,63],[307,94]],[[143,483],[318,261],[209,169],[143,133]],[[168,441],[217,370],[192,220],[263,112],[208,70],[173,65]],[[326,428],[451,394],[432,237],[397,53],[308,28],[267,105],[249,147],[327,193]],[[229,410],[314,372],[385,210],[408,42],[326,31],[236,20],[224,48],[222,77]],[[177,298],[91,328],[52,333],[22,273],[144,172],[188,146],[177,73]],[[317,558],[225,482],[211,494],[126,420],[261,318],[324,252],[257,185],[302,144]],[[214,393],[316,380],[307,318],[286,282],[356,247],[297,106],[277,48],[212,80]],[[274,455],[84,340],[33,272],[166,143],[259,62],[275,53]]]',
      times: '[13498,13486,14039,12345,19117,20076,14779,23386,17281,12504]',
      correct: '[true,true,false,false,true,true,false,true,false,true]',
      score: '5',
      time: 160511,
      started: true,
      name: 'Jane Archer',
    },
    createdTime: '2020-12-26T11:22:07.000Z',
  },
  {
    id: 'recPdeIzh1x85HvN3',
    fields: {
      raceNumber: 3830,
      paths:
        '[[[238,443],[235,409],[261,393],[215,7],[200,18],[231,172]],[[305,254],[29,178],[125,62],[295,40],[294,58],[309,66],[309,95]],[[143,483],[317,257],[144,130]],[[168,441],[218,373],[192,213],[265,106],[192,63],[166,61]],[[326,428],[342,426],[346,425],[374,405],[375,392],[416,408],[441,396],[396,56],[302,29],[251,147],[327,194]],[[229,410],[223,375],[170,352],[186,187],[34,173],[54,9],[222,19],[225,76]],[[177,298],[63,339],[27,277],[188,133],[168,72]],[[317,558],[291,535],[228,485],[205,491],[137,409],[325,241],[249,169],[311,145]],[[214,393],[159,315],[199,300],[225,303],[223,289],[149,147],[130,78],[210,51],[211,82]],[[274,455],[275,442],[458,361],[442,326],[424,113],[342,173],[297,137],[276,63]]]',
      times: '[8695,15235,8296,11426,23517,13925,7719,13328,12496,13164]',
      correct: '[true,true,false,false,true,false,false,true,true,false]',
      score: '4.5',
      time: 127801,
      started: true,
      name: 'Gill Sharp',
    },
    createdTime: '2020-12-26T11:22:07.000Z',
  },
  {
    id: 'recLnkT1CiHjri0Ij',
    fields: {
      raceNumber: 3832,
      paths:
        '[[[238,443],[259,403],[251,101],[221,7],[199,20],[238,176]],[[305,254],[22,190],[84,92],[204,28],[213,74],[303,96]],[[143,483],[315,252],[150,128],[135,134]],[[168,441],[221,372],[187,220],[263,107],[171,67]],[[326,428],[151,556],[19,396],[155,241],[257,152],[322,193]],[[229,410],[337,324],[406,191],[423,22],[222,17],[224,77]],[[177,298],[145,294],[63,338],[23,267],[196,144],[158,86],[175,64]],[[317,558],[570,300],[425,156],[323,248],[251,171],[305,148]],[[214,393],[387,312],[275,37],[211,78]],[[274,455],[478,372],[464,344],[245,296],[316,164],[281,57]]]',
      times: '[8051,9690,4538,11097,9715,11898,13218,10317,8656,13729]',
      correct: '[true,true,false,false,false,true,false,false,false,false]',
      score: '3',
      time: 100909,
      started: true,
      name: 'Alex Crawford',
    },
    createdTime: '2020-12-26T11:22:07.000Z',
  },
  {
    id: 'rechlRciLJd8Co8UB',
    fields: {
      raceNumber: 3843,
      paths:
        '[[[238,443],[255,213],[226,16],[229,165],[238,176]],[[305,254],[46,191],[47,155],[187,42],[294,43],[308,97]],[[143,483],[82,384],[70,213],[139,140]],[[168,441],[216,364],[261,250],[264,113],[174,60]],[[326,428],[433,390],[404,55],[305,27],[255,150],[323,193]],[[229,410],[316,361],[387,222],[400,39],[229,26],[220,74]],[[177,298],[62,338],[25,278],[182,140],[172,71]],[[317,558],[219,484],[127,414],[317,250],[255,184],[306,149]],[[214,393],[48,120],[205,56],[215,84]],[[274,455],[58,320],[34,262],[63,225],[266,58]]]',
      times: '[9560,6732,4984,9384,8301,9947,6684,6957,6849,6477]',
      correct: '[true,true,true,true,true,true,false,true,false,true]',
      score: '8',
      time: 75875,
      started: true,
      name: 'Nicolae Stroescu',
    },
    createdTime: '2020-12-23T21:30:52.000Z',
  },
  {
    id: 'rec4H54IxqbtCj8KX',
    fields: {
      raceNumber: 3845,
      paths:
        '[[[238,443],[65,387],[29,129],[235,175]],[[305,254],[492,323],[460,163],[298,45],[284,78],[304,98]],[[143,483],[74,393],[59,235],[139,135]],[[168,441],[217,376],[194,223],[262,115],[180,59],[174,66]],[[326,428],[450,388],[396,59],[305,29],[252,150],[322,195]],[[229,410],[302,383],[391,191],[407,44],[228,24],[223,75]],[[177,298],[204,320],[331,219],[245,99],[194,138],[171,75]],[[317,558],[237,489],[203,499],[129,423],[205,375],[330,251],[256,167],[297,136],[309,147]],[[214,393],[168,314],[196,303],[219,309],[236,282],[216,289],[133,83],[205,55],[214,81]],[[274,455],[467,379],[459,343],[249,296],[314,179],[276,59]]]',
      times: '[13027,15759,11923,13478,20791,13171,15138,15519,16459,14555]',
      correct: '[false,true,true,false,true,true,true,true,true,false]',
      score: '6.5',
      time: 149820,
      started: true,
      name: 'Paul Fox',
    },
    createdTime: '2020-12-26T11:22:07.000Z',
  },
  {
    id: 'recv9L6FzTHEyA1Co',
    fields: {
      raceNumber: 3870,
      paths:
        '[[[238,443],[262,426],[243,215],[225,170],[228,167]],[[305,254],[17,203],[299,39],[304,87]],[[143,483],[251,418],[313,291],[317,195],[169,111],[134,136]],[[168,441],[292,271],[197,212],[264,112],[175,64]],[[326,428],[171,554],[143,570],[22,380],[243,148],[325,190]],[[229,410],[229,376],[183,374],[206,183],[33,173],[47,7],[227,7],[225,70]],[[177,298],[56,333],[21,268],[193,135],[153,77],[165,67]],[[317,558],[224,484],[116,400],[321,243],[257,168],[299,136],[303,137],[290,131],[322,240],[323,250],[176,385],[119,403],[32,188],[126,165],[190,171],[254,178],[293,136],[301,143]],[[214,393],[395,312],[368,263],[218,293],[175,197],[126,75],[206,49],[219,78]],[[274,455],[47,315],[40,229],[274,49]]]',
      times: '[18067,7116,5564,14522,18372,17134,10275,60697,13870,16963]',
      correct: '[false,false,false,true,false,false,false,false,false,true]',
      score: '2',
      time: 182580,
      started: true,
      name: 'Rory Keen',
    },
    createdTime: '2020-12-26T11:22:07.000Z',
  },
  {
    id: 'recdr1lbZboORavhk',
    fields: {
      raceNumber: 3876,
      paths:
        '[[[238,443],[275,399],[224,16],[211,18],[235,173]],[[305,254],[32,185],[112,81],[201,43],[221,80],[304,95]],[[143,483],[310,259],[142,138]],[[168,441],[213,367],[193,220],[263,111],[172,65]],[[326,428],[355,444],[451,392],[431,268],[400,61],[305,30],[253,151],[325,194]],[[229,410],[314,365],[389,187],[405,43],[232,28],[225,77]],[[177,298],[154,323],[139,307],[64,331],[25,274],[179,143],[178,73]],[[317,558],[138,418],[325,249],[262,174],[309,149]],[[214,393],[170,315],[219,297],[138,81],[207,60],[216,80]],[[274,455],[43,300],[46,239],[270,56]]]',
      times: '[14896,15368,10486,11600,18969,13985,20499,19655,14952,13568]',
      correct: '[true,true,false,false,true,true,false,true,true,true]',
      score: '7',
      time: 153978,
      started: true,
      name: 'John Harbuck',
    },
    createdTime: '2020-12-24T18:45:18.000Z',
  },
  {
    id: 'rechjgAI5tooFJAmd',
    fields: {
      raceNumber: 3903,
      paths:
        '[[[238,443],[258,394],[242,82],[226,18],[213,10],[209,23],[233,174]],[[305,254],[443,299],[489,319],[493,299],[464,187],[429,130],[374,79],[313,44],[300,42],[298,59],[292,58],[248,68],[280,85],[306,99]],[[143,483],[90,452],[53,413],[133,301],[66,219],[141,139]],[[168,441],[214,373],[204,256],[195,230],[195,211],[260,114],[254,101],[186,64],[172,64]],[[326,428],[323,432],[319,458],[155,556],[50,413],[28,393],[249,150],[325,193]],[[229,410],[287,389],[312,356],[362,307],[404,62],[405,33],[230,18],[224,24],[224,74]],[[177,298],[160,317],[147,322],[138,304],[65,329],[26,286],[27,265],[180,151],[171,71]],[[317,558],[264,515],[232,492],[213,494],[184,484],[134,423],[132,410],[185,389],[312,258],[322,245],[262,186],[255,173],[290,136],[304,150]],[[214,393],[252,400],[273,398],[365,339],[386,325],[283,84],[272,53],[221,77]],[[274,455],[335,430],[412,413],[466,374],[467,347],[455,341],[448,328],[439,216],[439,153],[428,125],[400,132],[364,173],[323,173],[305,156],[275,55]]]',
      times: '[10172,22715,8735,13559,14320,15360,15663,19545,11456,22198]',
      correct: '[true,true,true,false,false,true,false,true,false,false]',
      score: '4.5',
      time: 153723,
      started: true,
      name: 'Friedmar Richter',
    },
    createdTime: '2020-12-26T11:22:07.000Z',
  },
  {
    id: 'recLM2qxLKUUGAwM3',
    fields: {
      raceNumber: 3912,
      paths:
        '[[[238,443],[236,172]],[[305,254],[25,184],[252,22],[308,92]],[[143,483],[314,261],[144,132]],[[168,441],[224,370],[32,246],[157,65],[164,64]]]',
      times: '[2743,7998,6777,12925]',
      correct: '[false,false,false,false]',
      score: '0',
      time: 30443,
      started: true,
      name: 'Jan Studer',
    },
    createdTime: '2020-12-26T11:22:07.000Z',
  },
  {
    id: 'rec5SiIHFFiyJreDy',
    fields: {
      raceNumber: 3914,
      paths:
        '[[[238,443],[264,390],[222,7],[201,22],[237,172]],[[305,254],[43,195],[55,126],[208,38],[211,79],[296,87],[310,99]],[[143,483],[312,265],[174,145],[144,127],[140,137]],[[168,441],[211,377],[46,245],[32,241],[150,66],[168,66]],[[326,428],[327,459],[450,385],[394,57],[307,30],[251,151],[325,191]],[[229,410],[322,336],[403,171],[409,38],[224,20],[223,77]],[[177,298],[202,323],[335,215],[241,98],[193,135],[163,87],[163,87],[171,71]],[[317,558],[228,489],[130,415],[82,328],[178,266],[150,168],[257,172],[307,145]],[[214,393],[157,322],[47,111],[168,64],[216,49],[217,81]],[[274,455],[29,271],[179,126],[268,52]]]',
      times: '[14184,13520,10784,16696,17695,14952,18591,26456,16992,9817]',
      correct: '[true,true,false,false,false,true,true,false,false,true]',
      score: '5',
      time: 159687,
      started: true,
      name: 'Richard Lewis',
    },
    createdTime: '2020-12-26T11:22:07.000Z',
  },
  {
    id: 'recAxGLf4PFZ24nUp',
    fields: {
      raceNumber: 3915,
      paths:
        '[[[238,443],[260,396],[239,22],[221,12],[203,20],[233,169]],[[305,254],[33,193],[71,102],[163,49],[206,42],[211,77],[271,84],[307,94]],[[143,483],[38,425],[120,314],[60,223],[135,131]],[[168,441],[224,373],[187,226],[263,110],[192,59],[172,65]],[[326,428],[335,462],[319,450],[344,454],[444,393],[448,385],[429,225],[393,53],[306,27],[247,145],[317,188],[324,190]],[[229,410],[303,385],[339,325],[390,213],[402,71],[403,36],[309,23],[227,21],[223,57],[224,82]],[[177,298],[205,321],[334,218],[249,102],[197,137],[165,95],[173,72]],[[317,558],[224,485],[206,499],[129,424],[189,382],[322,250],[262,186],[270,164],[291,139],[306,147]],[[214,393],[45,131],[49,118],[213,48],[217,83]],[[274,455],[129,374],[34,263],[109,196],[196,121],[272,56]]]',
      times: '[14760,16960,19368,17448,33765,26640,20506,25440,11888,22104]',
      correct: '[true,true,true,false,false,true,true,true,false,true]',
      score: '5',
      time: 208879,
      started: true,
      name: 'Grace Allinson',
    },
    createdTime: '2020-12-26T11:22:07.000Z',
  },
  {
    id: 'recQNQnbX7uKTByAu',
    fields: {
      raceNumber: 3916,
      paths:
        '[[[238,443],[263,390],[226,10],[205,18],[234,171]],[[305,254],[34,183],[208,46],[307,94]],[[143,483],[40,419],[135,296],[34,206],[124,101],[140,135]],[[168,441],[221,372],[36,240],[174,59]],[[326,428],[160,554],[49,371],[248,155],[320,198]],[[229,410],[368,298],[402,39],[221,26],[221,82]],[[177,298],[65,328],[17,273],[184,138],[172,73]],[[317,558],[219,491],[134,414],[327,250],[248,176],[305,147]],[[214,393],[171,301],[214,284],[144,74],[214,50],[217,80]],[[274,455],[35,240],[270,57]]]',
      times: '[11583,12049,10961,13801,25570,17784,11536,20071,12257,9641]',
      correct: '[true,false,false,false,false,true,false,true,true,true]',
      score: '4.5',
      time: 145253,
      started: true,
      name: 'Valentin Gheorghe',
    },
    createdTime: '2020-12-22T15:00:32.000Z',
  },
  {
    id: 'recdl3rUN1rKqnETI',
    fields: {
      raceNumber: 3917,
      paths:
        '[[[238,443],[258,394],[219,11],[207,19],[235,171]],[[305,254],[37,195],[36,169],[140,56],[192,45],[241,56],[307,98]],[[143,483],[74,382],[66,218],[141,141]],[[168,441],[216,373],[189,225],[258,106],[176,63]],[[326,428],[381,403],[427,392],[398,57],[305,28],[247,149],[324,190]],[[229,410],[29,260],[40,7],[218,28],[222,79]],[[177,298],[200,325],[331,218],[241,103],[195,130],[174,70]],[[317,558],[223,493],[132,424],[295,270],[322,252],[264,176],[302,145]],[[214,393],[384,318],[277,56],[219,78]],[[274,455],[52,316],[32,248],[78,211],[278,52]]]',
      times: '[6984,9071,4649,5272,13848,11016,13103,12736,8345,14432]',
      correct: '[true,true,true,false,false,false,true,true,false,true]',
      score: '6',
      time: 99456,
      started: true,
      name: 'Jean Le Pennec',
    },
    createdTime: '2020-12-26T11:22:07.000Z',
  },
]
